<template>
  <div id="PaSchoolFinder" class="wrap">
    <div class="maxContainer">
      <!-- Login or Signup Dialog -->
      <v-dialog
        v-model="signupLoginDialog"
        max-width="400"
        style="zindex: 3000"
      >
        <v-card style="borderradius: 10px">
          <v-card-title class="title grey lighten-2 text-xs-center">
            You Need an Account
            <v-spacer></v-spacer>
            <v-icon @click="signupLoginDialog = false" color="red"
              >mdi-close</v-icon
            >
          </v-card-title>
          <v-card-text class="text-xs-justify mt-1">
            <span class>
              You matched with
              <span
                class="font-weight-regular headline green--text text--darken-1 ml-1"
                >{{ filteredSchools.length }}</span
              >
              PA schools. Please login or signup to view your results
            </span>
          </v-card-text>

          <v-card-actions class="py-1 pb-2">
            <v-layout justify-center>
              <v-btn
                to="/LoginSignupPage"
                style="width: 48%"
                class="elevation-0"
                color="green"
                dark
                @click="showCreateSubscriptionDialog = false"
                >Login</v-btn
              >
              <v-btn
                to="/signup"
                style="width: 48%"
                class="elevation-0"
                color="primary"
                @click="showCreateSubscriptionDialog = false"
                >Signup</v-btn
              >
            </v-layout>
            <!--
              <v-btn  class="elevation-0" color="error" @click="showCreateSubscriptionDialog = false">
              Close
              </v-btn>
            -->
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Active Subscription Dialog -->
      <v-dialog
        v-model="activeSubscriptionDialog"
        max-width="400"
        style="zindex: 3000"
        persistent
      >
        <v-card style="borderradius: 5px">
          <v-card-title class="title grey lighten-2 text-xs-center">
            You need a subscription
            <v-spacer></v-spacer>
            <v-icon @click="activeSubscriptionDialog = false" color="red"
              >mdi-close</v-icon
            >
          </v-card-title>
          <v-card-text class="text-xs-justify mt-1">
            <span class="font-weight-light mt-1">
              You matched with
              <span
                class="font-weight-regular headline green--text text--darken-1 ml-1"
                >{{ filteredSchools.length }}</span
              >
              PA schools. You need an active subscription to view your results.
            </span>
          </v-card-text>

          <v-card-actions class="py-1 pb-2">
            <v-btn
              to="/myaccount"
              block
              class="elevation-0"
              color="primary"
              @click="showCreateSubscriptionDialog = false"
              >My account</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar
        v-model="noSchoolMatch"
        color="error"
        bottom
        style="zindex: 2000"
      >
        <v-layout column mt-1 align-center justify-center>
          <span class="subheading text-center">
            <v-icon class="mr-1" color="white">mdi-alert-box</v-icon>You did not
            match with any PA school. Please adjust your criteria to match with
            schools.
          </span>

          <v-btn dark text @click="noSchoolMatch = false">X Close</v-btn>
        </v-layout>
      </v-snackbar>

      <!-- Mobile Bar -->
      <!-- School Match -->
      <v-app-bar
        extended
        extension-height="100"
        class="white d-md-none fixScrollBar"
        fixed
        elevate-on-scroll
      >
        <v-layout class="mt-6 pt-5" column align-center justify-center>
          <v-layout column align-center justify-center wrap mt-5 pt-5>
            <span
              v-if="!checkIfFilterWasUsed"
              class="font-weight-regular display-3 yellow__text mt-4"
              >0</span
            >
            <span
              v-else
              class="font-weight-regular display-3 yellow__text mt-4"
              >{{ filteredSchools.length }}</span
            >
            <span class="font-weight-light mt-1">PA schools match</span>
          </v-layout>

          <v-layout
            class="pt-2 mt-2 px-5 scrolling-wrapper"
            row
            align-center
            justify-space-between
            style="width: 100%"
          >
            <v-layout
              v-if="!checkIfFilterWasUsed"
              class
              row
              align-center
              justify-center
            >
              <v-chip color="primary" outlined
                >Select your criteria to match with PA schools</v-chip
              >
            </v-layout>
            <v-layout v-else>
              <!-- Accreditation Status -->
              <div
                class="chip"
                v-if="
                  accreditationStatus !== '' &&
                  accreditationStatus !== undefined &&
                  accreditationStatus !== null
                "
              >
                <v-chip
                  class="mx-1"
                  @input="removeTuition"
                  color="green"
                  outlined
                  >Accreditation Status: {{ accreditationStatus }}</v-chip
                >
              </div>

              <!-- Tuition > $150,000 -->
              <div
                class="chip"
                v-if="
                  tuition !== '' &&
                  tuition !== undefined &&
                  tuition !== null &&
                  tuition === 'greaterThan150'
                "
              >
                <v-chip
                  class="mx-1"
                  @input="removeTuition"
                  color="green"
                  outlined
                  >Tuition: > $150,000</v-chip
                >
              </div>

              <!-- Tuition $100,000 - $150,000 -->
              <div
                class="chip"
                v-if="
                  tuition !== '' &&
                  tuition !== undefined &&
                  tuition !== null &&
                  tuition === '100to150'
                "
              >
                <v-chip
                  class="mx-1"
                  @input="removeTuition"
                  color="green"
                  outlined
                  >Tuition: $100,000 - $150,000</v-chip
                >
              </div>

              <!-- Tuition $50,000 - $100,000 -->
              <div
                class="chip"
                v-if="
                  tuition !== '' &&
                  tuition !== undefined &&
                  tuition !== null &&
                  tuition === '50to100'
                "
              >
                <v-chip
                  class="mx-1"
                  @input="removeTuition"
                  color="green"
                  outlined
                  >Tuition: $50,000 - $100,000</v-chip
                >
              </div>

              <!-- Tuition < $50,000 -->
              <div
                class="chip"
                v-if="
                  tuition !== '' &&
                  tuition !== undefined &&
                  tuition !== null &&
                  tuition === 'lessThan50'
                "
              >
                <v-chip
                  class="mx-1"
                  @input="removeTuition"
                  color="green"
                  outlined
                  >Tuition: < $50,000</v-chip
                >
              </div>

              <!-- Application Deadline Month -->
              <div
                class="chip"
                v-if="
                  application_deadline !== '' &&
                  application_deadline !== undefined &&
                  application_deadline !== null
                "
              >
                <v-chip
                  class="mx-1"
                  @input="removeTuition"
                  color="green"
                  outlined
                >
                  Deadline Month:
                  {{ application_deadline | moment(" MMM YYYY") }}
                </v-chip>
              </div>

              <!-- Military Only Chip -->
              <div
                class="chip"
                v-if="
                  militaryOnly !== '' &&
                  militaryOnly !== undefined &&
                  militaryOnly !== null &&
                  militaryOnly === 'true'
                "
              >
                <v-chip
                  class="mx-1"
                  @input="removeMilitaryOnly"
                  color="green"
                  outlined
                  >Military Only</v-chip
                >
              </div>

              <!-- International Students Accepted Chip -->
              <div
                class="chip"
                v-if="
                  internationalStudents !== '' &&
                  internationalStudents !== undefined &&
                  internationalStudents !== null &&
                  internationalStudents === 'true'
                "
              >
                <v-chip
                  class="mx-1"
                  @input="removeInternationalStudents"
                  color="green"
                  outlined
                  >International Students Accepted</v-chip
                >
              </div>

              <!-- On Campus Housing Available Chip -->
              <div
                class="chip"
                v-if="
                  onCampusHousing !== '' &&
                  onCampusHousing !== undefined &&
                  onCampusHousing !== null &&
                  onCampusHousing === 'true'
                "
              >
                <v-chip
                  class="mx-1"
                  @input="removeOnCampusHousing"
                  color="green"
                  outlined
                  >On Campus Housing Available</v-chip
                >
              </div>

              <!-- Faith Based Learning -->
              <div
                class="chip ma-1"
                v-if="
                  faithBasedLearning !== '' &&
                  faithBasedLearning !== undefined &&
                  faithBasedLearning !== null &&
                  faithBasedLearning === 'true'
                "
              >
                <v-chip class="mx-1" color="green" outlined
                  >Faith Based Learning</v-chip
                >
              </div>

              <!-- Cadaver Lab -->
              <div
                class="chip ma-1"
                v-if="
                  cadaverLab !== '' &&
                  cadaverLab !== undefined &&
                  cadaverLab !== null &&
                  cadaverLab === 'true'
                "
              >
                <v-chip class="mx-1" color="green" outlined>Cadaver Lab</v-chip>
              </div>

              <!-- Online Program Chip -->
              <div
                class="chip"
                v-if="
                  onlineProgram !== '' &&
                  onlineProgram !== undefined &&
                  onlineProgram !== null &&
                  onlineProgram === 'true'
                "
              >
                <v-chip
                  class="mx-1"
                  @input="removeOnlineProgram"
                  color="green"
                  outlined
                  >Online Program</v-chip
                >
              </div>

              <!-- Part Time Option Available Chip -->
              <div
                class="chip"
                v-if="
                  partTimeOption !== '' &&
                  partTimeOption !== undefined &&
                  partTimeOption !== null &&
                  partTimeOption === 'true'
                "
              >
                <v-chip
                  class="mx-1"
                  @input="removePartTimeOption"
                  color="green"
                  outlined
                  >Part Time Option Available</v-chip
                >
              </div>

              <!-- High School Entry Chip -->
              <div
                class="chip"
                v-if="
                  highSchoolEntry !== '' &&
                  highSchoolEntry !== undefined &&
                  highSchoolEntry !== null &&
                  highSchoolEntry === 'true'
                "
              >
                <v-chip
                  class="mx-1"
                  @input="removeHighSchoolEntry"
                  color="green"
                  outlined
                  >High School Entry</v-chip
                >
              </div>

              <!-- Pre PA Curriculum Chip -->
              <div
                class="chip"
                v-if="
                  preProfessionalTrack !== '' &&
                  preProfessionalTrack !== undefined &&
                  preProfessionalTrack !== null &&
                  preProfessionalTrack === 'true'
                "
              >
                <v-chip
                  class="mx-1"
                  @input="removepreProfessionalTrack"
                  color="green"
                  outlined
                  >Pre PA Curriculum</v-chip
                >
              </div>

              <!-- Rolling Admissions Chip -->
              <div
                class="chip"
                v-if="
                  rollingAdmissions !== '' &&
                  rollingAdmissions !== undefined &&
                  rollingAdmissions !== null &&
                  rollingAdmissions === 'true'
                "
              >
                <v-chip
                  class="mx-1"
                  @input="removepreRollingAdmissions"
                  color="green"
                  outlined
                  >Rolling Admissions</v-chip
                >
              </div>

              <!-- Non-Rolling Admissions Chip -->
              <div
                class="chip"
                v-if="
                  rollingAdmissions !== '' &&
                  rollingAdmissions !== undefined &&
                  rollingAdmissions !== null &&
                  rollingAdmissions === 'false'
                "
              >
                <v-chip
                  class="mx-1"
                  @input="removepreRollingAdmissions"
                  color="green"
                  outlined
                  >Non-Rolling Admissions</v-chip
                >
              </div>

              <!-- GRE not required chip -->
              <div
                class="chip"
                v-if="
                  gre !== '' &&
                  gre !== undefined &&
                  gre !== null &&
                  gre === 'not required'
                "
              >
                <v-chip
                  class="mx-1"
                  @input="removeGreNotRequired"
                  color="red"
                  outlined
                  >GRE not required</v-chip
                >
              </div>
              <!-- GRE required chip -->
              <div
                class="chip"
                v-if="
                  gre !== '' &&
                  gre !== undefined &&
                  gre !== null &&
                  gre === 'required'
                "
              >
                <v-chip @input="removeGreRequired" color="green" outline close
                  >GRE required</v-chip
                >
              </div>
              <!-- MCAT accepted in place of GRE -->
              <div
                class="chip"
                v-if="
                  mcatAccepted !== '' &&
                  mcatAccepted !== undefined &&
                  mcatAccepted !== null &&
                  mcatAccepted === 'true' &&
                  gre !== 'not required'
                "
              >
                <v-chip
                  class="mx-1"
                  @input="removeMcatAccepted"
                  color="green"
                  outlined
                  >MCAT accepted in place of GRE</v-chip
                >
              </div>
              <!-- GRE exempt with Master's or Doctoral Degree -->
              <div
                class="chip"
                v-if="
                  greExempt !== '' &&
                  greExempt !== undefined &&
                  greExempt !== null &&
                  greExempt === 'true' &&
                  gre !== 'not required'
                "
              >
                <v-chip
                  class="mx-1"
                  @input="removeGreExemptRequired"
                  color="green"
                  outlined
                  >GRE exempt with Master's or Doctoral Degree</v-chip
                >
              </div>

              <!-- CASPer required -->
              <div class="chip" v-if="casperRequired === 'true'">
                <v-chip class="mx-1" color="green" outlined
                  >CASPer required</v-chip
                >
              </div>
              <!-- CASPer not required chip -->
              <div class="chip" v-if="casperRequired === 'false'">
                <v-chip color="red" outlined>CASPer not required</v-chip>
              </div>

              <!-- PACAT required -->
              <div class="chip" v-if="pacatRequired === 'true'">
                <v-chip class="mx-1" color="green" outlined
                  >PA-CAT required</v-chip
                >
              </div>
              <!-- PACAT not required chip -->
              <div class="chip" v-if="pacatRequired === 'false'">
                <v-chip color="red" outlined>PA-CAT not required</v-chip>
              </div>

              <!-- PA Shadowing Hours recommended chip -->
              <div
                class="chip"
                v-if="
                  paShadowing !== '' &&
                  paShadowing !== undefined &&
                  paShadowing !== null &&
                  paShadowing === 'recommended'
                "
              >
                <v-chip
                  @input="removePaShadowingHoursNotRequired"
                  color="amber darken-3"
                  outlined
                  >PA Shadowing hours recommended</v-chip
                >
              </div>
              <!-- PA Shadowing Hours not required chip -->
              <div
                class="chip"
                v-if="
                  paShadowing !== '' &&
                  paShadowing !== undefined &&
                  paShadowing !== null &&
                  paShadowing === 'not required'
                "
              >
                <v-chip
                  @input="removePaShadowingHoursNotRequired"
                  class="mx-1"
                  color="red"
                  outlined
                  >PA Shadowing hours not required</v-chip
                >
              </div>
              <!-- Minimum PA Shadowing Hours Chip -->
              <div
                class="chip"
                v-if="
                  minimumPaShadowingHours !== '' &&
                  minimumPaShadowingHours !== undefined &&
                  minimumPaShadowingHours !== null &&
                  this.paShadowing !== 'not required'
                "
              >
                <v-chip
                  @input="removePaShadowingHours"
                  class="mx-1"
                  color="green"
                  outlined
                >
                  Min PA Shadowing Hours: {{ minimumPaShadowingHours }}
                  <span class="ml-1">hrs</span>
                </v-chip>
              </div>

              <!-- Healthcare Hours Not Required Chip -->
              <div
                class="chip"
                v-if="
                  healthcareExperience !== '' &&
                  healthcareExperience !== undefined &&
                  healthcareExperience !== null &&
                  healthcareExperience === 'not required'
                "
              >
                <v-chip
                  class="mx-1"
                  @input="removeHealthcareHoursNotRequired"
                  color="red"
                  outlined
                  >Healthcare hours not required</v-chip
                >
              </div>
              <!-- Healthcare Hours  Recommended Chip -->
              <div
                class="chip"
                v-if="
                  healthcareExperience !== '' &&
                  healthcareExperience !== undefined &&
                  healthcareExperience !== null &&
                  healthcareExperience === 'recommended'
                "
              >
                <v-chip
                  class="mx-1"
                  @input="removeHealthcareHoursNotRequired"
                  color="amber darken-3"
                  text-color="white"
                  >Healthcare hours recommended</v-chip
                >
              </div>
              <!-- Minimum Healthcare Hours Chip -->
              <div
                class="chip"
                v-if="
                  minimumHealthcareHours !== '' &&
                  minimumHealthcareHours !== undefined &&
                  minimumHealthcareHours !== null &&
                  healthcareExperience !== 'not required'
                "
              >
                <v-chip
                  class="mx-1"
                  @input="removeHealthcareHours"
                  color="green"
                  outlined
                >
                  Min Healthcare Hours: {{ minimumHealthcareHours }}
                  <span class="ml-1">hrs</span>
                </v-chip>
              </div>

              <!-- GPA Not Required Chip -->
              <div
                class="chip"
                v-if="
                  searchMinGpa !== '' &&
                  searchMinGpa !== undefined &&
                  searchMinGpa !== null
                "
              >
                <v-chip
                  class="mx-1"
                  @input="removeGpaNotRequired"
                  color="red"
                  outlined
                  >GPA not required</v-chip
                >
              </div>
              <!-- Science GPA Chip -->
              <div
                class="chip"
                v-if="
                  searchScienceGpa !== '' &&
                  searchScienceGpa !== undefined &&
                  searchScienceGpa !== null &&
                  searchMinGpa !== 'not required'
                "
              >
                <v-chip
                  class="mx-1"
                  @input="removeScienceGpa"
                  color="green"
                  outlined
                  >Science GPA: {{ searchScienceGpa }}</v-chip
                >
              </div>
              <!-- Overall GPA Chip -->
              <div
                class="chip"
                v-if="
                  searchOverallGpa !== '' &&
                  searchOverallGpa !== undefined &&
                  searchOverallGpa !== null &&
                  searchMinGpa !== 'not required'
                "
              >
                <v-chip
                  class="mx-1"
                  @click:close="removeOverallGpa"
                  color="green"
                  outlined
                  >Overall GPA: {{ searchOverallGpa }}</v-chip
                >
              </div>
              <!-- State Chip -->
              <div
                class="chip"
                v-for="state in searchState"
                :key="state.index"
                v-if="
                  searchState.length !== 0 &&
                  searchState !== undefined &&
                  searchState !== null
                "
              >
                <v-chip
                  class="mx-1"
                  @input="removeState(state)"
                  color="green"
                  outlined
                  >State: {{ state }}</v-chip
                >
              </div>

              <!-- Include / Exclude lessons -->
              <div
                class="chip ma-1"
                v-for="course in selectedCategory"
                :key="course"
              >
                <v-chip class="mx-1" color="green" outlined>{{
                  course
                }}</v-chip>
              </div>
            </v-layout>
          </v-layout>
        </v-layout>
      </v-app-bar>

      <div class="hidden-sm-and-down text-center">
        <div class="filterBarContainer">
          <div class="maxContainer">
            <div class="filterBarContainer__wrapper">
              <div>
                <v-layout align-baseline>
                  <v-layout column align-center justify-center wrap>
                    <span
                      v-if="!checkIfFilterWasUsed"
                      class="font-weight-regular display-4 yellow__text mt-4"
                      >0</span
                    >
                    <span
                      v-else
                      class="font-weight-regular display-4 yellow__text mt-4"
                      >{{ filteredSchools.length }}</span
                    >
                    <span class="font-weight-light mt-1">PA schools match</span>
                    <div class="pt-4 fullWidth text-center">
                      <!--
                        <div class="pt-4">
                          <v-btn  v-if="showResults === false" color="green lighten-1 "  class="elevation-6"  dark    @click="showSchools"> View Results</v-btn>
                        </div>
                      -->
                      <v-btn
                        v-if="checkIfFilterWasUsed && showResults === false"
                        color="green lighten-1 "
                        class="elevation-6"
                        dark
                        @click="showSchools"
                        >View Results</v-btn
                      >
                      <v-btn
                        v-if="showResults"
                        class="elevation-6"
                        color="amber darken-1"
                        dark
                        @click="showResults = !showResults"
                      >
                        <v-icon small class="mr-2">mdi-filter</v-icon>Edit
                        Filter
                      </v-btn>
                    </div>
                  </v-layout>
                </v-layout>
                <v-layout class="pt-2 px-5">
                  <v-layout
                    v-if="!checkIfFilterWasUsed"
                    class
                    row
                    align-center
                    justify-center
                  >
                    <v-chip class="ml-5" color="primary" outlined
                      >Select your criteria to match with PA schools</v-chip
                    >
                    <div class="pt-4 fullWidth text-center">
                      <v-btn
                        v-if="checkIfFilterWasUsed && showResults === false"
                        color="green lighten-1 "
                        class="elevation-6"
                        dark
                        @click="showSchools"
                        >View Results</v-btn
                      >
                      <v-btn
                        v-if="showResults"
                        class="elevation-6"
                        color="amber darken-1"
                        dark
                        @click="showResults = !showResults"
                      >
                        <v-icon small class="mr-2">mdi-filter</v-icon>Edit
                        Filter
                      </v-btn>
                    </div>
                  </v-layout>
                  <div v-else class="fullWidth">
                    <div
                      class="py-2"
                      v-if="
                        searchState.length !== 0 &&
                        searchState !== undefined &&
                        searchState !== null
                      "
                    >
                      <h4 class>State</h4>
                      <div class="layout flex-wrap chipContainer">
                        <!-- State Chip -->
                        <div
                          class="chip ma-1"
                          v-for="state in searchState"
                          :key="state.index"
                          v-if="
                            searchState.length !== 0 &&
                            searchState !== undefined &&
                            searchState !== null
                          "
                        >
                          <v-chip
                            class="mx-1"
                            @input="removeState(state)"
                            color="green"
                            outlined
                            >State: {{ state }}</v-chip
                          >
                        </div>
                      </div>
                    </div>

                    <div
                      class="py-2"
                      v-if="
                        tuition !== '' &&
                        tuition !== undefined &&
                        tuition !== null
                      "
                    >
                      <h4 class>Tuition</h4>
                      <div class="layout flex-wrap chipContainer">
                        <!-- Tuition > $150,000 -->
                        <div
                          class="chip ma-1"
                          v-if="
                            tuition !== '' &&
                            tuition !== undefined &&
                            tuition !== null &&
                            tuition === 'greaterThan150'
                          "
                        >
                          <v-chip
                            class="mx-1"
                            @input="removeTuition"
                            color="green"
                            outlined
                            >Tuition: > $150,000</v-chip
                          >
                        </div>

                        <!-- Tuition $100,000 - $150,000 -->
                        <div
                          class="chip ma-1"
                          v-if="
                            tuition !== '' &&
                            tuition !== undefined &&
                            tuition !== null &&
                            tuition === '100to150'
                          "
                        >
                          <v-chip
                            class="mx-1"
                            @input="removeTuition"
                            color="green"
                            outlined
                            >Tuition: $100,000 - $150,000</v-chip
                          >
                        </div>

                        <!-- Tuition $50,000 - $100,000 -->
                        <div
                          class="chip ma-1"
                          v-if="
                            tuition !== '' &&
                            tuition !== undefined &&
                            tuition !== null &&
                            tuition === '50to100'
                          "
                        >
                          <v-chip
                            class="mx-1"
                            @input="removeTuition"
                            color="green"
                            outlined
                            >Tuition: $50,000 - $100,000</v-chip
                          >
                        </div>

                        <!-- Tuition < $50,000 -->
                        <div
                          class="chip ma-1"
                          v-if="
                            tuition !== '' &&
                            tuition !== undefined &&
                            tuition !== null &&
                            tuition === 'lessThan50'
                          "
                        >
                          <v-chip
                            class="mx-1"
                            @input="removeTuition"
                            color="green"
                            outlined
                            >Tuition: < $50,000</v-chip
                          >
                        </div>
                      </div>
                    </div>

                    <div
                      class="py-2"
                      v-if="
                        accreditationStatus !== '' &&
                        accreditationStatus !== undefined &&
                        accreditationStatus !== null
                      "
                    >
                      <h4 class>Accreditation Status</h4>
                      <div class="layout flex-wrap chipContainer">
                        <!-- Accreditation Status -->
                        <div
                          class="chip ma-1"
                          v-if="
                            accreditationStatus !== '' &&
                            accreditationStatus !== undefined &&
                            accreditationStatus !== null
                          "
                        >
                          <v-chip
                            class="mx-1"
                            @input="removeTuition"
                            color="green"
                            outlined
                          >
                            Accreditation Status:
                            {{ accreditationStatus }}
                          </v-chip>
                        </div>
                      </div>
                    </div>

                    <div
                      class="py-2"
                      v-if="
                        (searchOverallGpa !== '' &&
                          searchOverallGpa !== undefined &&
                          searchOverallGpa !== null) ||
                        (searchScienceGpa !== '' &&
                          searchScienceGpa !== undefined &&
                          searchScienceGpa !== null) ||
                        (searchMinGpa !== '' &&
                          searchMinGpa !== undefined &&
                          searchMinGpa !== null)
                      "
                    >
                      <h4 class>GPA</h4>
                      <div class="layout flex-wrap chipContainer">
                        <!-- GPA Not Required Chip -->
                        <div
                          class="chip ma-1"
                          v-if="
                            searchMinGpa !== '' &&
                            searchMinGpa !== undefined &&
                            searchMinGpa !== null
                          "
                        >
                          <v-chip
                            class="mx-1"
                            @input="removeGpaNotRequired"
                            color="red"
                            outlined
                            >GPA not required</v-chip
                          >
                        </div>

                        <!-- Science GPA Chip -->
                        <div
                          class="chip ma-1"
                          v-if="
                            searchScienceGpa !== '' &&
                            searchScienceGpa !== undefined &&
                            searchScienceGpa !== null &&
                            searchMinGpa !== 'not required'
                          "
                        >
                          <v-chip
                            class="mx-1"
                            @input="removeScienceGpa"
                            color="green"
                            outlined
                            >Science GPA: {{ searchScienceGpa }}</v-chip
                          >
                        </div>
                        <!-- Overall GPA Chip -->
                        <div
                          class="chip ma-1"
                          v-if="
                            searchOverallGpa !== '' &&
                            searchOverallGpa !== undefined &&
                            searchOverallGpa !== null &&
                            searchMinGpa !== 'not required'
                          "
                        >
                          <v-chip
                            class="mx-1"
                            @click:close="removeOverallGpa"
                            color="green"
                            outlined
                            >Overall GPA: {{ searchOverallGpa }}</v-chip
                          >
                        </div>
                      </div>
                    </div>

                    <div
                      class="py-2"
                      v-if="
                        (healthcareExperience !== '' &&
                          healthcareExperience !== undefined &&
                          healthcareExperience !== null) ||
                        (minimumHealthcareHours !== '' &&
                          minimumHealthcareHours !== undefined &&
                          minimumHealthcareHours !== null)
                      "
                    >
                      <h4 class>PCE Hours</h4>
                      <div class="layout flex-wrap chipContainer">
                        <!-- Healthcare Hours Not Required Chip -->
                        <div
                          class="chip ma-1"
                          v-if="
                            healthcareExperience !== '' &&
                            healthcareExperience !== undefined &&
                            healthcareExperience !== null &&
                            healthcareExperience === 'not required'
                          "
                        >
                          <v-chip
                            class="mx-1"
                            @input="removeHealthcareHoursNotRequired"
                            color="red"
                            outlined
                            >Healthcare hours not required</v-chip
                          >
                        </div>
                        <!-- Healthcare Hours  Recommended Chip -->
                        <div
                          class="chip ma-1"
                          v-if="
                            healthcareExperience !== '' &&
                            healthcareExperience !== undefined &&
                            healthcareExperience !== null &&
                            healthcareExperience === 'recommended'
                          "
                        >
                          <v-chip
                            class="mx-1"
                            @input="removeHealthcareHoursNotRequired"
                            color="amber darken-3"
                            text-color="white"
                            >Healthcare hours recommended</v-chip
                          >
                        </div>
                        <!-- Minimum Healthcare Hours Chip -->
                        <div
                          class="chip ma-1"
                          v-if="
                            minimumHealthcareHours !== '' &&
                            minimumHealthcareHours !== undefined &&
                            minimumHealthcareHours !== null &&
                            healthcareExperience !== 'not required'
                          "
                        >
                          <v-chip
                            class="mx-1"
                            @input="removeHealthcareHours"
                            color="green"
                            outlined
                          >
                            Min Healthcare Hours: {{ minimumHealthcareHours }}
                            <span class="ml-1">hrs</span>
                          </v-chip>
                        </div>
                      </div>
                    </div>

                    <div
                      class="py-2"
                      v-if="
                        (paShadowing !== '' &&
                          paShadowing !== undefined &&
                          paShadowing !== null) ||
                        (minimumPaShadowingHours !== '' &&
                          minimumPaShadowingHours !== undefined &&
                          minimumPaShadowingHours !== null)
                      "
                    >
                      <h4 class>PA Shadowing</h4>
                      <div class="layout flex-wrap chipContainer">
                        <!-- PA Shadowing Hours recommended chip -->
                        <div
                          class="chip ma-1"
                          v-if="
                            paShadowing !== '' &&
                            paShadowing !== undefined &&
                            paShadowing !== null &&
                            paShadowing === 'recommended'
                          "
                        >
                          <v-chip
                            @input="removePaShadowingHoursNotRequired"
                            color="amber darken-3"
                            outlined
                            >PA Shadowing hours recommended</v-chip
                          >
                        </div>
                        <!-- PA Shadowing Hours not required chip -->
                        <div
                          class="chip ma-1"
                          v-if="
                            paShadowing !== '' &&
                            paShadowing !== undefined &&
                            paShadowing !== null &&
                            paShadowing === 'not required'
                          "
                        >
                          <v-chip
                            @input="removePaShadowingHoursNotRequired"
                            class="mx-1"
                            color="red"
                            outlined
                            >PA Shadowing hours not required</v-chip
                          >
                        </div>
                        <!-- Minimum PA Shadowing Hours Chip -->
                        <div
                          class="chip ma-1"
                          v-if="
                            minimumPaShadowingHours !== '' &&
                            minimumPaShadowingHours !== undefined &&
                            minimumPaShadowingHours !== null &&
                            this.paShadowing !== 'not required'
                          "
                        >
                          <v-chip
                            @input="removePaShadowingHours"
                            class="mx-1"
                            color="green"
                            outlined
                          >
                            Min PA Shadowing Hours:
                            {{ minimumPaShadowingHours }}
                            <span class="ml-1">hrs</span>
                          </v-chip>
                        </div>
                      </div>
                    </div>

                    <div
                      class="py-2"
                      v-if="
                        (gre !== '' && gre !== undefined && gre !== null) ||
                        casperRequired === 'true' ||
                        casperRequired === 'false' ||
                        pacatRequired === 'true' ||
                        pacatRequired === 'false' ||
                        (mcatAccepted !== '' && mcatAccepted) ||
                        (greExempt !== '' &&
                          greExempt !== undefined &&
                          greExempt !== null)
                      "
                    >
                      <h4 class>Exams</h4>
                      <div class="layout flex-wrap chipContainer">
                        <!-- GRE not required chip -->
                        <div
                          class="chip ma-1"
                          v-if="
                            gre !== '' &&
                            gre !== undefined &&
                            gre !== null &&
                            gre === 'not required'
                          "
                        >
                          <v-chip
                            class="mx-1"
                            @input="removeGreNotRequired"
                            color="red"
                            outlined
                            >GRE not required</v-chip
                          >
                        </div>
                        <!-- GRE required chip -->
                        <div
                          class="chip ma-1"
                          v-if="
                            gre !== '' &&
                            gre !== undefined &&
                            gre !== null &&
                            gre === 'required'
                          "
                        >
                          <v-chip
                            @input="removeGreRequired"
                            color="green"
                            outline
                            close
                            >GRE required</v-chip
                          >
                        </div>
                        <!-- MCAT accepted in place of GRE -->
                        <div
                          class="chip ma-1"
                          v-if="
                            mcatAccepted !== '' &&
                            mcatAccepted !== undefined &&
                            mcatAccepted !== null &&
                            mcatAccepted === 'true' &&
                            gre !== 'not required'
                          "
                        >
                          <v-chip
                            class="mx-1"
                            @input="removeMcatAccepted"
                            color="green"
                            outlined
                            >MCAT accepted in place of GRE</v-chip
                          >
                        </div>
                        <!-- GRE exempt with Master's or Doctoral Degree -->
                        <div
                          class="chip ma-1"
                          v-if="
                            greExempt !== '' &&
                            greExempt !== undefined &&
                            greExempt !== null &&
                            greExempt === 'true' &&
                            gre !== 'not required'
                          "
                        >
                          <v-chip
                            class="mx-1"
                            @input="removeGreExemptRequired"
                            color="green"
                            outlined
                            >GRE exempt with Master's or Doctoral Degree</v-chip
                          >
                        </div>

                        <!-- CASPer required -->
                        <div class="chip ma-1" v-if="casperRequired === 'true'">
                          <v-chip class="mx-1" color="green" outlined
                            >CASPer required</v-chip
                          >
                        </div>
                        <!-- CASPer not required chip -->
                        <div
                          class="chip ma-1"
                          v-if="casperRequired === 'false'"
                        >
                          <v-chip color="red" outlined
                            >CASPer not required</v-chip
                          >
                        </div>

                        <!-- PACAT required -->
                        <div class="chip ma-1" v-if="pacatRequired === 'true'">
                          <v-chip class="mx-1" color="green" outlined
                            >PA-CAT required</v-chip
                          >
                        </div>
                        <!-- PACAT not required chip -->
                        <div class="chip ma-1" v-if="pacatRequired === 'false'">
                          <v-chip color="red" outlined
                            >PA-CAT not required</v-chip
                          >
                        </div>
                      </div>
                    </div>

                    <div
                      class="py-2"
                      v-if="
                        militaryOnly === 'true' ||
                        internationalStudents === 'true' ||
                        onCampusHousing === 'true' ||
                        onlineProgram === 'true' ||
                        partTimeOption === 'true' ||
                        highSchoolEntry === 'true' ||
                        preProfessionalTrack === 'true' ||
                        rollingAdmissions === 'true' ||
                        rollingAdmissions === 'false' ||
                        cadaverLab === 'true' ||
                        faithBasedLearning === 'true'
                      "
                    >
                      <h4 class>Program Details</h4>
                      <div class="layout flex-wrap chipContainer">
                        <!-- Military Only Chip -->
                        <div
                          class="chip ma-1"
                          v-if="
                            militaryOnly !== '' &&
                            militaryOnly !== undefined &&
                            militaryOnly !== null &&
                            militaryOnly === 'true'
                          "
                        >
                          <v-chip
                            class="mx-1"
                            @input="removeMilitaryOnly"
                            color="green"
                            outlined
                            >Military Only</v-chip
                          >
                        </div>

                        <!-- International Students Accepted Chip -->
                        <div
                          class="chip ma-1"
                          v-if="
                            internationalStudents !== '' &&
                            internationalStudents !== undefined &&
                            internationalStudents !== null &&
                            internationalStudents === 'true'
                          "
                        >
                          <v-chip
                            class="mx-1"
                            @input="removeInternationalStudents"
                            color="green"
                            outlined
                            >International Students Accepted</v-chip
                          >
                        </div>

                        <!-- On Campus Housing Available Chip -->
                        <div
                          class="chip ma-1"
                          v-if="
                            onCampusHousing !== '' &&
                            onCampusHousing !== undefined &&
                            onCampusHousing !== null &&
                            onCampusHousing === 'true'
                          "
                        >
                          <v-chip
                            class="mx-1"
                            @input="removeOnCampusHousing"
                            color="green"
                            outlined
                            >On Campus Housing Available</v-chip
                          >
                        </div>

                        <!-- Online Program Chip -->
                        <div
                          class="chip ma-1"
                          v-if="
                            onlineProgram !== '' &&
                            onlineProgram !== undefined &&
                            onlineProgram !== null &&
                            onlineProgram === 'true'
                          "
                        >
                          <v-chip
                            class="mx-1"
                            @input="removeOnlineProgram"
                            color="green"
                            outlined
                            >Online Program</v-chip
                          >
                        </div>

                        <div
                          class="chip ma-1"
                          v-if="
                            faithBasedLearning !== '' &&
                            faithBasedLearning !== undefined &&
                            faithBasedLearning !== null &&
                            faithBasedLearning === 'true'
                          "
                        >
                          <v-chip class="mx-1" color="green" outlined
                            >Faith Based Learning</v-chip
                          >
                        </div>

                        <div
                          class="chip ma-1"
                          v-if="
                            cadaverLab !== '' &&
                            cadaverLab !== undefined &&
                            cadaverLab !== null &&
                            cadaverLab === 'true'
                          "
                        >
                          <v-chip class="mx-1" color="green" outlined
                            >Cadaver Lab</v-chip
                          >
                        </div>

                        <!-- Part Time Option Available Chip -->
                        <div
                          class="chip ma-1"
                          v-if="
                            partTimeOption !== '' &&
                            partTimeOption !== undefined &&
                            partTimeOption !== null &&
                            partTimeOption === 'true'
                          "
                        >
                          <v-chip
                            class="mx-1"
                            @input="removePartTimeOption"
                            color="green"
                            outlined
                            >Part Time Option Available</v-chip
                          >
                        </div>

                        <!-- High School Entry Chip -->
                        <div
                          class="chip ma-1"
                          v-if="
                            highSchoolEntry !== '' &&
                            highSchoolEntry !== undefined &&
                            highSchoolEntry !== null &&
                            highSchoolEntry === 'true'
                          "
                        >
                          <v-chip
                            class="mx-1"
                            @input="removeHighSchoolEntry"
                            color="green"
                            outlined
                            >High School Entry</v-chip
                          >
                        </div>

                        <!-- Pre PA Curriculum Chip -->
                        <div
                          class="chip ma-1"
                          v-if="
                            preProfessionalTrack !== '' &&
                            preProfessionalTrack !== undefined &&
                            preProfessionalTrack !== null &&
                            preProfessionalTrack === 'true'
                          "
                        >
                          <v-chip
                            class="mx-1"
                            @input="removepreProfessionalTrack"
                            color="green"
                            outlined
                            >Pre PA Curriculum</v-chip
                          >
                        </div>

                        <!-- Rolling Admissions Chip -->
                        <div
                          class="chip ma-1"
                          v-if="
                            rollingAdmissions !== '' &&
                            rollingAdmissions !== undefined &&
                            rollingAdmissions !== null &&
                            rollingAdmissions === 'true'
                          "
                        >
                          <v-chip
                            class="mx-1"
                            @input="removepreRollingAdmissions"
                            color="green"
                            outlined
                            >Rolling Admissions</v-chip
                          >
                        </div>

                        <!-- Non-Rolling Admissions Chip -->
                        <div
                          class="chip ma-1"
                          v-if="
                            rollingAdmissions !== '' &&
                            rollingAdmissions !== undefined &&
                            rollingAdmissions !== null &&
                            rollingAdmissions === 'false'
                          "
                        >
                          <v-chip
                            class="mx-1"
                            @input="removepreRollingAdmissions"
                            color="green"
                            outlined
                            >Non-Rolling Admissions</v-chip
                          >
                        </div>
                      </div>
                    </div>

                    <div
                      class="py-2"
                      v-if="
                        application_deadline !== '' &&
                        application_deadline !== undefined &&
                        application_deadline !== null
                      "
                    >
                      <h4 class>Application Deadline Month</h4>
                      <div class="layout flex-wrap chipContainer">
                        <!-- Application Deadline Month -->
                        <div
                          class="chip ma-1"
                          v-if="
                            application_deadline !== '' &&
                            application_deadline !== undefined &&
                            application_deadline !== null
                          "
                        >
                          <v-chip
                            class="mx-1"
                            @input="removeTuition"
                            color="green"
                            outlined
                          >
                            Deadline Month:
                            {{ application_deadline | moment(" MMM YYYY") }}
                          </v-chip>
                        </div>
                      </div>
                    </div>

                    <div class="py-2" v-if="this.selectedCategory.length">
                      <h4 v-if="includeCoursesState == 'true'" class>
                        Included Courses
                      </h4>
                      <h4 v-if="includeCoursesState == 'false'" class>
                        Excluded Courses
                      </h4>
                      <div class="layout flex-wrap chipContainer">
                        <!-- Include / Exclude lessons -->
                        <div
                          class="chip ma-1"
                          v-for="course in selectedCategory"
                          :key="course"
                        >
                          <v-chip class="mx-1" color="green" outlined>
                            {{ course }}
                          </v-chip>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-layout>
              </div>
            </div>
          </div>
        </div>

        <div class="flex-grow-1"></div>
      </div>

      <!-- </v-app-bar> -->

      <v-card class="card--flex-toolbar mt-10 mb-5 pb-1" flat>
        <!-- School Match Filter Criteria -->
        <div v-if="showResults === false" id="filter">
          <v-container class="criteriaContainer" pl-0 pr-0>
            <v-row>
              <v-col lg="12">
                <v-expansion-panels>
                  <!-- State -->
                  <v-expansion-panels focusable class="containerCard">
                    <v-expansion-panel>
                      <v-expansion-panel-header
                        class="title light-blue--text text--darken-4 elevation-0"
                        >State</v-expansion-panel-header
                      >
                      <v-expansion-panel-content>
                        <v-container pt-0>
                          <v-layout column>
                            <v-select
                              :items="states"
                              v-model="searchState"
                              label="Select States"
                              class="pt-3"
                              clearable
                              outlined
                              single-line
                              color="green darken-1"
                              prepend-inner-icon="mdi-map-marker"
                              multiple
                              small-chips
                              deletable-chips
                              hide-details
                            ></v-select>
                          </v-layout>
                        </v-container>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>

                  <!-- Tuition -->
                  <v-expansion-panels focusable class="mt-5">
                    <v-expansion-panel>
                      <v-expansion-panel-header
                        class="title light-blue--text text--darken-4 elevation-0"
                        >Tuition</v-expansion-panel-header
                      >
                      <v-expansion-panel-content>
                        <v-container class="pt-3">
                          <v-layout column>
                            <v-radio-group
                              v-model="tuitionOption"
                              class="pt-0 mt-0 mb-0"
                              hide-details
                              row
                            >
                              <v-radio
                                mandatory="false"
                                label="In State"
                                value="in state"
                                color="green"
                              ></v-radio>
                              <v-radio
                                mandatory="false"
                                label="Out of State"
                                value="out of state"
                                color="green"
                              ></v-radio>
                            </v-radio-group>
                            <v-divider class="pt-0 mt-3 mb-3"></v-divider>

                            <v-layout column>
                              <v-checkbox
                                color="green darken-1"
                                v-model="tuition"
                                class="mt-0 pt-0 mb-0 pb-0"
                                label="< $50,000"
                                value="lessThan50"
                              ></v-checkbox>
                              <v-checkbox
                                color="green darken-1"
                                v-model="tuition"
                                class="mt-0 pt-0 mb-0 pb-0"
                                label="$50,000 - $100,000"
                                value="50to100"
                              ></v-checkbox>
                              <v-checkbox
                                color="green darken-1"
                                v-model="tuition"
                                class="mt-0 pt-0 mb-0 pb-0"
                                label="$100,000 - $150,000"
                                value="100to150"
                              ></v-checkbox>
                              <v-checkbox
                                color="green darken-1"
                                v-model="tuition"
                                class="mt-0 pt-0 mb-0 pb-0"
                                label="> $150,000"
                                value="greaterThan150"
                              ></v-checkbox>
                            </v-layout>
                          </v-layout>
                        </v-container>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>

                  <!-- Accreditation Status -->
                  <v-expansion-panels focusable class="mt-5">
                    <v-expansion-panel>
                      <v-expansion-panel-header
                        class="title light-blue--text text--darken-4 elevation-0"
                      >
                        Accreditation Status
                        <v-layout row align-baseline class="ml-1">
                          <v-icon
                            @click="showAccreditationInfoDialog = true"
                            class="mr-2"
                            >mdi-information</v-icon
                          >
                        </v-layout>
                        <!-- Accreditation Status Info -->
                        <v-dialog
                          v-model="showAccreditationInfoDialog"
                          scrollable
                          max-width="400"
                          style="zindex: 2000"
                          persistent
                        >
                          <v-card style="borderradius: 5px">
                            <v-card-title class="title grey lighten-2"
                              >Accreditation Status</v-card-title
                            >
                            <v-card-text class="text-xs-justify mt-1">
                              <p class="mt-1 mb-2">
                                <strong>Accreditation-Continued</strong> is
                                granted 1) when a currently accredited program
                                is in compliance with the Standards, 2) in the
                                case of a program holding
                                Accreditation-Probation when the program has
                                demonstrated that it is once again in compliance
                                with the Standards, or 3) when a program holding
                                Accreditation-Provisional demonstrates
                                compliance with the Standards after completion
                                of the provisional review process.
                                Accreditation-continued status remains in effect
                                until the program closes or withdraws from the
                                accreditation process or until accreditation is
                                withdrawn for failure to comply with the
                                Standards.
                              </p>

                              <p class="mt-0 mb-2">
                                <strong>Accreditation–Provisional</strong> is an
                                accreditation status granted when the plans and
                                resource allocation, if fully implemented as
                                planned, of a proposed program that has not yet
                                enrolled students appear to demonstrate the
                                program’s ability to meet the ARC-PA Standards
                                or when a program holding
                                accreditation-provisional status appears to
                                demonstrate continued progress in complying with
                                the Standards as it prepares for the graduation
                                of the first class (cohort) of students.
                              </p>

                              <p class="mt-0 mb-2">
                                <strong>Accreditation-Probationary</strong> is a
                                temporary, status of accreditation, limited to
                                two years, granted when a program holding an
                                accreditation status of
                                accreditation-provisional or
                                accreditation-continued does not meet the
                                Standards and when the capability of the program
                                to provide an acceptable educational experience
                                for its students is threatened. Once placed on
                                probation, a program that fails to comply with
                                accreditation requirements in a timely manner,
                                as specified by the ARC-PA, may be scheduled for
                                a focused site visit and/or risk having its
                                accreditation withdrawn.
                              </p>

                              <p class="mt-2">
                                <strong>
                                  Accreditation-Administrative Probation
                                </strong>
                                is a temporary status granted when a program has
                                not complied with an administrative requirement,
                                such as failure to pay fees or submit required
                                reports. Once placed on Administrative
                                Probation, a program that fails to comply with
                                administrative requirements in a timely manner,
                                as specified by the ARC-PA, may be scheduled for
                                a focused site visit and/or risk having its
                                accreditation withdrawn.
                              </p>
                            </v-card-text>
                            <v-card-actions>
                              <v-btn
                                @click="showAccreditationInfoDialog = false"
                                block
                                color="red"
                                dark
                                class="elevation-0"
                                >Close</v-btn
                              >
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-container class="pt-3 pb-0">
                          <v-layout column>
                            <v-select
                              :items="status"
                              color="green darken-1"
                              single-line
                              v-model="accreditationStatus"
                              label="Select status"
                              outlined
                              clearable
                              class="mt-0 pt-0"
                              hide-details
                            ></v-select>
                          </v-layout>
                        </v-container>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>

                  <!-- GPA -->
                  <v-expansion-panels focusable class="mt-5">
                    <v-expansion-panel>
                      <v-expansion-panel-header
                        class="title light-blue--text text--darken-4 elevation-0 pb-0"
                      >
                        <v-layout row align-baseline class="ml-1">
                          GPA
                          <v-switch
                            label="not required"
                            v-model="searchMinGpa"
                            class="mt-0 pt-2 mb-0 pb-0 ml-3"
                            color="red"
                            value="not required"
                            style="maxheight: 40px"
                          ></v-switch>
                          <v-icon @click="showGpaInfoDialog = true" class="ml-2"
                            >mdi-information</v-icon
                          >
                        </v-layout>
                        <!-- GPA Filter Info -->
                        <v-dialog
                          v-model="showGpaInfoDialog"
                          scrollable
                          max-width="400"
                          style="zindex: 2000"
                          persistent
                        >
                          <v-card style="borderradius: 5px">
                            <v-card-title
                              class="title grey lighten-2 text-xs-center"
                              >GPA Match</v-card-title
                            >
                            <v-card-text class="text-xs-justify mt-2">
                              Most PA programs require minimum Overall/Science
                              GPA’s. This feature pairs you with programs
                              accepting your GPA. Programs with higher minimum
                              GPA’s would be excluded.
                              <p class="mt-2">
                                For example: By entering a 3.4 overall GPA the
                                filter displays programs accepting a 3.4 GPA or
                                less and programs with no minimum GPA
                                requirements.
                              </p>
                              If you are seeking PA programs without GPA
                              requirements, just click on “Not Required”.
                            </v-card-text>
                            <v-card-actions>
                              <v-btn
                                @click="showGpaInfoDialog = false"
                                block
                                color="red"
                                dark
                                class="elevation-0"
                                >Close</v-btn
                              >
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-expansion-panel-header>

                      <v-expansion-panel-content>
                        <v-container
                          v-if="searchMinGpa !== 'not required'"
                          class="pt-4 pb-4"
                        >
                          <v-layout column class>
                            <!-- Minimum Overall GPA -->
                            <!--
                              <span class="pl-0 pb-0 green--text text--darken-1 font-weight-regular">Overall GPA</span>
                            -->
                            <v-text-field
                              v-model="searchOverallGpa"
                              label="Overall GPA"
                              outlined
                              color="green"
                              hide-details
                              clearable
                            ></v-text-field>

                            <!-- Minimum Science GPA -->
                            <!--
                              <span class="pl-0  pt-2 pb-0 green--text text--darken-1 font-weight-regular">My Science GPA</span>
                            -->

                            <v-text-field
                              v-model="searchScienceGpa"
                              label="Science GPA"
                              outlined
                              clearable
                              color="green"
                              class="mt-4 pt-0"
                              hide-details
                            ></v-text-field>
                          </v-layout>
                        </v-container>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>

                  <!-- Prerequisites -->
                  <v-expansion-panels focusable class="mt-5">
                    <v-expansion-panel>
                      <v-expansion-panel-header
                        class="title light-blue--text text--darken-4 elevation-0"
                        >Prerequisites</v-expansion-panel-header
                      >
                      <v-expansion-panel-content>
                        <v-radio-group
                          row
                          v-model="includeCoursesState"
                          class="makeItDouble__radioCover ml-5"
                        >
                          <v-radio
                            label="Include Courses"
                            value="true"
                          ></v-radio>
                          <v-radio
                            label="Exclude Courses"
                            value="false"
                          ></v-radio>
                        </v-radio-group>
                        <v-layout class="mt-3 pt-0 pb-0" column>
                          <v-tabs
                            vertical
                            class="IncExcCourseTab showOnlyTabletUp"
                          >
                            <v-tab
                              class="justify-start"
                              v-for="i in courseCategories"
                              :key="i.title"
                              >{{ i.title }}</v-tab
                            >
                            <v-tab-item
                              v-for="i in courseCategories"
                              :key="i.title"
                            >
                              <v-card flat>
                                <v-card-text>
                                  <v-checkbox
                                    v-for="item in i.courses"
                                    :key="item"
                                    color="green darken-1"
                                    v-model="selectedCategory"
                                    class="mt-0 pt-0 mb-0 pb-0"
                                    :label="`${item}`"
                                    :value="`${item}`"
                                  ></v-checkbox>
                                </v-card-text>
                              </v-card>
                            </v-tab-item>
                          </v-tabs>

                          <v-expansion-panels multiple class="showOnlyMobile">
                            <div class="makeItDouble">
                              <v-expansion-panel
                                v-for="i in courseCategories"
                                :key="i.title"
                              >
                                <v-expansion-panel-header
                                  class="title light-blue--text text--darken-4 elevation-0 incExcTitle"
                                  >{{ i.title }}</v-expansion-panel-header
                                >
                                <v-expansion-panel-content>
                                  <div class="makeItDouble__cont mt-5">
                                    <v-checkbox
                                      v-for="item in i.courses"
                                      :key="item"
                                      color="green darken-1"
                                      v-model="selectedCategory"
                                      class="mt-0 pt-0 mb-0 pb-0"
                                      :label="`${item}`"
                                      :value="`${item}`"
                                    ></v-checkbox>
                                  </div>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </div>
                          </v-expansion-panels>
                        </v-layout>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>

                  <!-- Healthcare Experience -->
                  <v-expansion-panels focusable class="mt-5">
                    <v-expansion-panel>
                      <v-expansion-panel-header
                        class="title light-blue--text text--darken-4 elevation-0 pb-0"
                      >
                        <v-layout align-baseline>
                          PCE Hours
                          <v-switch
                            label="not required"
                            v-model="healthcareExperience"
                            class="mt-0 pt-2 mb-0 pb-0 ml-3"
                            color="red"
                            value="not required"
                            style="maxheight: 40px"
                          ></v-switch>
                          <v-icon
                            @click="showHealthcareInfoDialog = true"
                            class="ml-1"
                            >mdi-information</v-icon
                          >
                        </v-layout>
                        <!-- Healthcare Experience Info -->
                        <v-dialog
                          v-model="showHealthcareInfoDialog"
                          scrollable
                          max-width="400"
                          style="zindex: 2000"
                          persistent
                        >
                          <v-card style="borderradius: 5px">
                            <v-card-title class="title grey lighten-2"
                              >Patient Care Experience Hrs Match</v-card-title
                            >
                            <v-card-text class="text-xs-justify mt-2">
                              Most PA programs require applicants to have
                              minimum healthcare/patient care experience hours.
                              This feature pairs you with programs accepting
                              your experience hours. Schools with higher minimum
                              healthcare/patient care hours would be excluded.
                              <p class="mt-2">
                                For example: By entering 500 healthcare/patient
                                care hours the filter displays programs
                                accepting your hours or less and programs with
                                no minimum healthcare/patient care hours
                                requirements.
                              </p>
                              If you are seeking PA programs without
                              healthcare/patient care requirements, just click
                              on “Not Required”.
                            </v-card-text>
                            <v-card-actions>
                              <v-btn
                                @click="showHealthcareInfoDialog = false"
                                block
                                color="red"
                                dark
                                class="elevation-0"
                                >Close</v-btn
                              >
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-container
                          v-if="healthcareExperience !== 'not required'"
                          pt-3
                          pb-0
                        >
                          <v-layout column>
                            <!-- Minimum Required healthcare hours -->
                            <v-text-field
                              v-model="minimumHealthcareHours"
                              label="Healthcare Hours"
                              small
                              color="green"
                              clearable
                              outlined
                              hide-details
                            ></v-text-field>
                          </v-layout>
                        </v-container>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>

                  <!-- PA Shadowing -->
                  <v-expansion-panels focusable class="mt-5">
                    <v-expansion-panel>
                      <v-expansion-panel-header
                        class="title light-blue--text text--darken-4 elevation-0 pb-0"
                      >
                        <v-layout align-baseline>
                          PA Shadowing
                          <v-switch
                            label="not required"
                            v-model="paShadowing"
                            class="mt-0 pt-2 mb-0 pb-0 ml-3"
                            color="red"
                            value="not required"
                            style="maxheight: 40px"
                          ></v-switch>
                          <v-icon
                            @click="showPaShadowingInfoDialog = true"
                            class="ml-1"
                            >mdi-information</v-icon
                          >
                        </v-layout>
                        <!-- PA Shadowing Info -->
                        <v-dialog
                          v-model="showPaShadowingInfoDialog"
                          scrollable
                          max-width="400"
                          style="zindex: 2000"
                          persistent
                        >
                          <v-card style="borderradius: 5px">
                            <v-card-title class="title grey lighten-2"
                              >PA Shadowing Hours Match</v-card-title
                            >
                            <v-card-text class="text-xs-justify mt-2">
                              Most PA programs require applicants to have
                              minimum PA shadowing hours. This feature pairs you
                              with programs accepting your shadowing hours.
                              Schools with higher minimum PA shadowing hours
                              would be excluded.
                              <p class="mt-2">
                                For example: By entering 50 shadowing hours the
                                filter displays programs accepting your hours or
                                less and programs with no minimum PA shadowing
                                requirements.
                              </p>
                              If you are seeking PA programs without PA
                              shadowing requirements, just click on “Not
                              Required”.
                            </v-card-text>
                            <v-card-actions>
                              <v-btn
                                @click="showPaShadowingInfoDialog = false"
                                block
                                color="red"
                                dark
                                class="elevation-0"
                                >Close</v-btn
                              >
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-container
                          v-if="paShadowing !== 'not required'"
                          pt-3
                          pb-0
                        >
                          <v-layout column>
                            <!-- My PA Shadowing Hours -->
                            <v-text-field
                              v-model="minimumPaShadowingHours"
                              label="Shadowing Hours"
                              color="green"
                              clearable
                              small
                              outlined
                              hide-details
                            ></v-text-field>
                          </v-layout>
                        </v-container>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>

                  <!-- Exams -->
                  <v-expansion-panels focusable class="mt-5">
                    <v-expansion-panel>
                      <v-expansion-panel-header
                        class="title light-blue--text text--darken-4 elevation-0"
                        >Exams</v-expansion-panel-header
                      >
                      <v-expansion-panel-content>
                        <v-container pt-0>
                          <!-- GRE -->
                          <v-card
                            class="pt-0 mt-5"
                            style="borderradius: 5px"
                            id="buttonShadow"
                          >
                            <v-card-title
                              class="grey lighten-3 pt-1 mb-0 mx-0 mt-0 pb-1 pr-1"
                            >
                              <v-layout align-baseline>
                                <span
                                  class="title font-weight-medium light-blue--text text--darken-4"
                                  >GRE</span
                                >
                                <v-switch
                                  label="not required"
                                  v-model="gre"
                                  class="mt-0 pt-2 mb-0 pb-0 ml-3"
                                  color="red"
                                  value="not required"
                                  style="maxheight: 40px"
                                ></v-switch>
                              </v-layout>
                              <v-spacer></v-spacer>
                              <v-icon
                                @click="showGreInfoDialog = true"
                                class="mr-2"
                                >mdi-information</v-icon
                              >
                            </v-card-title>
                            <!-- GRE  Info -->
                            <v-dialog
                              v-model="showGreInfoDialog"
                              scrollable
                              max-width="400"
                              style="zindex: 2000"
                              persistent
                            >
                              <v-card style="borderradius: 5px">
                                <v-card-title class="title grey lighten-2"
                                  >GRE Match</v-card-title
                                >
                                <v-card-text class="text-xs-justify mt-2">
                                  The GRE is the most common standardized test
                                  required by PA programs.
                                  <p class="mt-2">
                                    By clicking “Not required”, programs without
                                    GRE requirements will be displayed.
                                  </p>
                                  Few PA programs accept a Medical College
                                  Admission Test (MCAT) in place of GRE. If you
                                  have taken the MCAT and do not plan on taking
                                  the GRE, selecting this option will display PA
                                  schools accepting MCAT in place of the GRE.
                                </v-card-text>
                                <v-card-actions>
                                  <v-btn
                                    @click="showGreInfoDialog = false"
                                    block
                                    color="red"
                                    dark
                                    class="elevation-0"
                                    >Close</v-btn
                                  >
                                </v-card-actions>
                              </v-card>
                            </v-dialog>

                            <v-container
                              v-if="gre !== 'not required'"
                              class="mx-0 mt-4 pt-0 pb-0"
                            >
                              <v-layout column>
                                <v-layout column>
                                  <v-checkbox
                                    color="green darken-1"
                                    v-model="mcatAccepted"
                                    class="mt-0 pt-0 mb-0 pb-0"
                                    label="MCAT accepted in place of GRE"
                                    value="true"
                                  ></v-checkbox>
                                  <v-checkbox
                                    color="green darken-1"
                                    v-model="greExempt"
                                    class="mt-0 pt-0 mb-0 pb-0"
                                    label="GRE exempt with Master's or Doctoral Degree"
                                    value="true"
                                  ></v-checkbox>
                                </v-layout>
                              </v-layout>
                            </v-container>
                          </v-card>

                          <!-- CASPER -->
                          <v-card
                            class="pt-0 mt-5"
                            style="borderradius: 5px"
                            id="buttonShadow"
                          >
                            <v-card-title
                              class="grey lighten-3 pt-1 mb-0 mx-0 mt-0 pb-1 pr-1"
                            >
                              <v-layout align-baseline>
                                <span
                                  class="title font-weight-medium light-blue--text text--darken-4"
                                  >CASPer</span
                                >
                              </v-layout>
                              <v-spacer></v-spacer>
                              <v-icon
                                @click="showCasperInfoDialog = true"
                                class="mr-2"
                                >mdi-information</v-icon
                              >
                            </v-card-title>
                            <!-- CASPer  Info -->
                            <v-dialog
                              v-model="showCasperInfoDialog"
                              scrollable
                              max-width="400"
                              style="zindex: 2000"
                              persistent
                            >
                              <v-card style="borderradius: 5px">
                                <v-card-title class="title grey lighten-2"
                                  >CASPer Match</v-card-title
                                >
                                <v-card-text class="text-xs-justify mt-2">
                                  CASPer® (Computer-based Assessment for
                                  Sampling Personal Characteristics) is a 90
                                  minute, web-based, situational judgment test
                                  (SJT). It is a component of the application
                                  process used by certain medical schools,
                                  health sciences, education, and veterinary
                                  programs in an effort to evaluate your
                                  personal and professional characteristics.
                                  CASPer® is an online test used to help screen
                                  applicants as part of the school's application
                                  process, as one of several criteria assessed
                                  in determining candidates' invitations to
                                  interview (where applicable) and admission to
                                  the program.
                                  <p class="mt-2">
                                    By clicking “Required”, programs that
                                    require CASPer will be displayed.
                                  </p>
                                </v-card-text>
                                <v-card-actions>
                                  <v-btn
                                    @click="showCasperInfoDialog = false"
                                    block
                                    color="red"
                                    dark
                                    class="elevation-0"
                                    >Close</v-btn
                                  >
                                </v-card-actions>
                              </v-card>
                            </v-dialog>

                            <v-container class="mx-0 mt-4 pt-0 pb-0">
                              <v-layout column>
                                <v-layout column>
                                  <v-checkbox
                                    color="green darken-1"
                                    v-model="casperRequired"
                                    class="mt-0 pt-0 mb-0 pb-0"
                                    label="Required"
                                    value="true"
                                  ></v-checkbox>
                                  <v-checkbox
                                    color="green darken-1"
                                    v-model="casperRequired"
                                    class="mt-0 pt-0 mb-0 pb-0"
                                    label="Not Required"
                                    value="false"
                                  ></v-checkbox>
                                </v-layout>
                              </v-layout>
                            </v-container>
                          </v-card>

                          <!-- PA-Cat -->
                          <v-card
                            class="pt-0 mt-5"
                            style="borderradius: 5px"
                            id="buttonShadow"
                          >
                            <v-card-title
                              class="grey lighten-3 pt-1 mb-0 mx-0 mt-0 pb-1 pr-1"
                            >
                              <v-layout align-baseline>
                                <span
                                  class="title font-weight-medium light-blue--text text--darken-4"
                                  >PA-CAT</span
                                >
                              </v-layout>
                              <v-spacer></v-spacer>
                              <v-icon
                                @click="showPacatInfoDialog = true"
                                class="mr-2"
                                >mdi-information</v-icon
                              >
                            </v-card-title>
                            <v-dialog
                              v-model="showPacatInfoDialog"
                              scrollable
                              max-width="400"
                              style="zindex: 2000"
                              persistent
                            >
                              <v-card style="borderradius: 5px">
                                <v-card-title class="title grey lighten-2"
                                  >PA-CAT Match</v-card-title
                                >
                                <v-card-text class="text-xs-justify mt-2">
                                  The Physician Assistant College Admission Test
                                  (PA-CAT™) is a specialized test that is
                                  designed to measure applicant knowledge and
                                  application in key prerequisite science
                                  subjects typically required for PA school. The
                                  PA-CAT measures general academic ability and
                                  scientific knowledge necessary for success in
                                  the demanding Physician Assistant curriculum.
                                  The PA-CAT has been developed specifically for
                                  use by PA educators and admissions experts as
                                  part of a holistic admissions process.
                                  <p class="mt-2">
                                    By clicking “Required”, programs that
                                    require PA-CAT will be displayed.
                                  </p>
                                </v-card-text>
                                <v-card-actions>
                                  <v-btn
                                    @click="showPacatInfoDialog = false"
                                    block
                                    color="red"
                                    dark
                                    class="elevation-0"
                                    >Close</v-btn
                                  >
                                </v-card-actions>
                              </v-card>
                            </v-dialog>

                            <v-container class="mx-0 mt-4 pt-0 pb-0">
                              <v-layout column>
                                <v-layout column>
                                  <v-checkbox
                                    color="green darken-1"
                                    v-model="pacatRequired"
                                    class="mt-0 pt-0 mb-0 pb-0"
                                    label="Required"
                                    value="true"
                                  ></v-checkbox>
                                  <v-checkbox
                                    color="green darken-1"
                                    v-model="pacatRequired"
                                    class="mt-0 pt-0 mb-0 pb-0"
                                    label="Not Required"
                                    value="false"
                                  ></v-checkbox>
                                </v-layout>
                              </v-layout>
                            </v-container>
                          </v-card>
                        </v-container>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>

                  <!-- Program Details -->
                  <v-expansion-panels focusable class="mt-5">
                    <v-expansion-panel>
                      <v-expansion-panel-header
                        class="title light-blue--text text--darken-4 elevation-0"
                        >Program Details</v-expansion-panel-header
                      >
                      <v-expansion-panel-content>
                        <v-container class="pt-0">
                          <v-layout column class="mt-3">
                            <v-layout column class="mt-2">
                              <v-layout align-center mb-4>
                                <v-checkbox
                                  color="green darken-1"
                                  v-model="rollingAdmissions"
                                  hide-details
                                  class="mt-0 pt-0 mb-0 pb-0 shrink"
                                  label="Rolling admissions"
                                  value="true"
                                ></v-checkbox>
                                <v-icon
                                  @click="
                                    showRollingAdmissionsInfoDialog = true
                                  "
                                  small
                                  class="mb-2 ml-2"
                                  >mdi-information</v-icon
                                >
                                <v-checkbox
                                  color="green darken-1"
                                  v-model="rollingAdmissions"
                                  hide-details
                                  class="mt-0 pt-0 mb-0 pb-0 shrink ml-5"
                                  label="Non-Rolling admissions"
                                  value="false"
                                ></v-checkbox>
                              </v-layout>

                              <!-- Rolling Admissions Info -->
                              <v-dialog
                                v-model="showRollingAdmissionsInfoDialog"
                                scrollable
                                max-width="400"
                                style="zindex: 2000"
                                persistent
                              >
                                <v-card style="borderradius: 5px">
                                  <v-card-title class="title grey lighten-2"
                                    >Rolling Admission</v-card-title
                                  >
                                  <v-card-text class="text-xs-justify mt-2">
                                    Simply means, “First come, first serve”.
                                    Applications are assessed for enrollment as
                                    they are received. Schools with rolling
                                    admission can reach class capacity before
                                    the application deadline is reached. You
                                    should take advantage by applying early to
                                    schools offering rolling admission because
                                    the earlier you apply the better chance you
                                    have.
                                  </v-card-text>
                                  <v-card-actions>
                                    <v-btn
                                      @click="
                                        showRollingAdmissionsInfoDialog = false
                                      "
                                      block
                                      color="red"
                                      dark
                                      class="elevation-0"
                                      >Close</v-btn
                                    >
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>

                              <!-- Pre PA Curriculum -->
                              <v-layout align-center mb-4>
                                <v-checkbox
                                  color="green darken-1"
                                  v-model="preProfessionalTrack"
                                  hide-details
                                  class="mt-0 pt-0 mb-0 pb-0 shrink"
                                  label="Pre PA curriculum"
                                  value="true"
                                ></v-checkbox>
                                <v-icon
                                  @click="showFreshmenEntryInfoDialog = true"
                                  small
                                  class="mb-2 ml-2"
                                  >mdi-information</v-icon
                                >
                              </v-layout>

                              <!-- Pre PA Curriculum Info -->
                              <v-dialog
                                v-model="showFreshmenEntryInfoDialog"
                                scrollable
                                max-width="400"
                                style="zindex: 2000"
                                persistent
                              >
                                <v-card style="borderradius: 5px">
                                  <v-card-title class="title grey lighten-2"
                                    >Pre PA Curriculum</v-card-title
                                  >
                                  <v-card-text class="text-xs-justify mt-2">
                                    Selecting this displays schools that have a
                                    Pre-PA Curriculum for students aspiring to
                                    become a physician assistant early on.
                                    Preference is given to these students when
                                    applying to the school’s PA program (if they
                                    meet all the required prerequisites).
                                  </v-card-text>

                                  <v-card-actions>
                                    <v-btn
                                      @click="
                                        showFreshmenEntryInfoDialog = false
                                      "
                                      block
                                      color="red"
                                      dark
                                      class="elevation-0"
                                      >Close</v-btn
                                    >
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>

                              <!-- High School Entry -->
                              <v-layout align-center mb-4>
                                <v-checkbox
                                  color="green darken-1"
                                  v-model="highSchoolEntry"
                                  hide-details
                                  class="mt-0 pt-0 mb-0 pb-0 shrink"
                                  label="High school entry"
                                  value="true"
                                ></v-checkbox>
                                <v-icon
                                  @click="showHighSchoolEntryInfoDialog = true"
                                  small
                                  class="mb-2 ml-2"
                                  >mdi-information</v-icon
                                >
                              </v-layout>

                              <!-- High School Entry Info -->
                              <v-dialog
                                v-model="showHighSchoolEntryInfoDialog"
                                scrollable
                                max-width="400"
                                style="zindex: 2000"
                                persistent
                              >
                                <v-card style="borderradius: 5px">
                                  <v-card-title class="title grey lighten-2"
                                    >High School Entry</v-card-title
                                  >
                                  <v-card-text class="text-xs-justify mt-2">
                                    Clicking this checkbox displays schools
                                    accepting high school graduates directly to
                                    their PA program.
                                  </v-card-text>
                                  <v-card-actions>
                                    <v-btn
                                      @click="
                                        showHighSchoolEntryInfoDialog = false
                                      "
                                      block
                                      color="red"
                                      dark
                                      class="elevation-0"
                                      >Close</v-btn
                                    >
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>

                              <v-layout align-center mb-4>
                                <v-checkbox
                                  color="green darken-1"
                                  v-model="cadaverLab"
                                  hide-details
                                  class="mt-0 pt-0 mb-0 pb-0 shrink"
                                  label="Cadaver Lab"
                                  value="true"
                                ></v-checkbox>
                              </v-layout>

                              <v-layout align-center mb-4>
                                <v-checkbox
                                  color="green darken-1"
                                  v-model="faithBasedLearning"
                                  hide-details
                                  class="mt-0 pt-0 mb-0 pb-0 shrink"
                                  label="Faith Based Learning"
                                  value="true"
                                ></v-checkbox>
                              </v-layout>

                              <v-layout align-center mb-4>
                                <v-checkbox
                                  color="green darken-1"
                                  v-model="partTimeOption"
                                  hide-details
                                  class="mt-0 pt-0 mb-0 pb-0 shrink"
                                  label="Part time option"
                                  value="true"
                                ></v-checkbox>
                              </v-layout>

                              <v-layout align-center mb-4>
                                <v-checkbox
                                  color="green darken-1"
                                  v-model="onlineProgram"
                                  hide-details
                                  class="mt-0 pt-0 mb-0 pb-0"
                                  label="Online program"
                                  value="true"
                                ></v-checkbox>
                              </v-layout>

                              <v-layout align-center mb-4>
                                <v-checkbox
                                  color="green darken-1"
                                  v-model="onCampusHousing"
                                  hide-details
                                  class="mt-0 pt-0 mb-0 pb-0"
                                  label="On campus housing "
                                  value="true"
                                ></v-checkbox>
                              </v-layout>

                              <v-layout align-center mb-4>
                                <v-checkbox
                                  color="green darken-1"
                                  v-model="internationalStudents"
                                  hide-details
                                  class="mt-0 pt-0 mb-0 pb-0"
                                  label="International students accepted"
                                  value="true"
                                ></v-checkbox>
                              </v-layout>
                              <v-layout align-center mb-4>
                                <v-checkbox
                                  color="green darken-1"
                                  v-model="militaryOnly"
                                  hide-details
                                  class="mt-1 pt-0 mb-0 pb-0"
                                  label="Military personal only"
                                  value="true"
                                ></v-checkbox>
                              </v-layout>
                            </v-layout>
                          </v-layout>
                        </v-container>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>

                  <!-- Application Deadline -->
                  <v-expansion-panels focusable class="mt-5">
                    <v-expansion-panel>
                      <v-expansion-panel-header
                        class="title light-blue--text text--darken-4 elevation-0"
                      >
                        Application Deadline
                        <v-layout align-center>
                          <v-icon
                            @click="showDeadlineInfoDialog = true"
                            class="ml-1"
                            >mdi-information</v-icon
                          >
                        </v-layout>
                        <!-- Deadline Info -->
                        <v-dialog
                          v-model="showDeadlineInfoDialog"
                          scrollable
                          max-width="400"
                          style="zindex: 2000"
                          persistent
                        >
                          <v-card style="borderradius: 5px">
                            <v-card-title class="title grey lighten-2"
                              >Application Deadline Match</v-card-title
                            >
                            <v-card-text class="text-xs-justify mt-2">
                              The application deadline filter will display PA
                              schools by their application deadline (month).
                              This displays schools that are accepting
                              applications from the month you selected until the
                              end of the application cycle.
                              <p class="mt-2">
                                For example: By selecting the month 05/2023 for
                                the 2023-2024 application cycle, the filter will
                                display all schools that have deadlines from
                                05/2023 through 4/01/24 (deadline to submit your
                                application to CASPA).
                              </p>
                            </v-card-text>
                            <v-card-actions>
                              <v-btn
                                @click="showDeadlineInfoDialog = false"
                                block
                                color="red"
                                dark
                                class="elevation-0"
                                >Close</v-btn
                              >
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-container class="mt-3 pt-0 pb-0">
                          <v-radio-group
                            v-model="cycleOption"
                            class="pt-0 mt-0 mb-0"
                            hide-details
                            row
                          >
                            <!-- <v-radio
                              mandatory="false"
                              label="2021-2022 Cycle"
                              value="2021cycle"
                              color="green"
                            ></v-radio> -->
                            <v-radio
                              mandatory="false"
                              label="2024-2025 Cycle"
                              value="2024cycle"
                              color="green"
                            ></v-radio>
                             <v-radio
                              mandatory="false"
                              label="2025-2026 Cycle"
                              value="2025cycle"
                              color="green"
                            ></v-radio>
                          </v-radio-group>
                          <v-divider class="pt-0 mt-3 mb-3"></v-divider>

                          <v-layout column>
                            <v-menu
                              ref="menu2"
                              :close-on-content-click="false"
                              v-model="menu2"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              full-width
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  slot="activator"
                                  color="green darken-1"
                                  v-model="application_deadline"
                                  outlined
                                  label="Select month"
                                  prepend-inner-icon="mdi-calendar"
                                  readonly
                                  clearable
                                  class="mt-0 pt-0"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                color="green darken-1"
                                type="month"
                                no-title
                                v-model="application_deadline"
                                @change="menu2 = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-layout>
                        </v-container>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-expansion-panels>


                  <!-- Class Start Month -->
                  <v-expansion-panels focusable class="mt-5">
                    <v-expansion-panel>
                      <v-expansion-panel-header class="title light-blue--text text--darken-4 elevation-0">
                        Class Start Month
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-container class="mt-3 pt-0 pb-0">

                          <v-layout column>
                            <v-menu
                              ref="menu3"
                              :close-on-content-click="false"
                              v-model="menu3"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              full-width
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  slot="activator"
                                  color="green darken-1"
                                  v-model="application_classStartMonth"
                                  outlined
                                  label="Select month"
                                  prepend-inner-icon="mdi-calendar"
                                  readonly
                                  clearable
                                  class="mt-0 pt-0"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                color="green darken-1"
                                type="month"
                                no-title
                                v-model="application_classStartMonth"
                                @change="menu3 = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-layout>
                        </v-container>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </v-container>
        </div>

        <!-- School Match Results -->
        <div v-if="showResults === true" class style="marginbottom: 80px">
          <v-container class="px-0 pt-0">
            <v-layout
              class="destopAligner"
              column
              align-center
              justify-center
              mt-4
            >
              <h2 class="display-1 font-weight-regular blue--text">Results</h2>
            </v-layout>

            <!-- Mobile Results -->
            <div class="white d-md-none mt-5">
              <v-card
                v-if="recommendedSchools.length !== 0"
                flat
                class="mt-2"
                outlined
              >
                <v-toolbar flat class="pb-0">
                  <v-icon color="green">mdi-thumb-up</v-icon>
                  <v-toolbar-title class="ml-2 green--text pb-0">
                    {{ recommendedSchools.length }}
                    <span class="ml-2">Recommended Schools</span>
                  </v-toolbar-title>

                  <v-spacer></v-spacer>

                  <v-icon @click="showRecommendedDialog = true"
                    >mdi-information</v-icon
                  >
                </v-toolbar>
                <!-- Recommended Schools Info Dialog -->
                <v-dialog
                  v-model="showRecommendedDialog"
                  scrollable
                  max-width="400"
                  style="zindex: 2000"
                  persistent
                >
                  <v-card style="borderradius: 5px">
                    <v-card-title class="title grey lighten-2"
                      >Recommended Schools</v-card-title
                    >
                    <v-card-text class="text-xs-justify mt-2">
                      𝐑𝐄𝐂𝐎𝐌𝐌𝐄𝐍𝐃𝐄𝐃 𝐒𝐂𝐇𝐎𝐎𝐋𝐒 are displayed when you meet and/or
                      exceed either the minimum GPA or the minimum healthcare
                      hours of students accepted in the prior cycle.⁣ ⁣
                      <p class="mt-2">
                        𝐇𝐈𝐆𝐇𝐋𝐘 𝐑𝐄𝐂𝐎𝐌𝐌𝐄𝐍𝐃𝐄𝐃 𝐒𝐂𝐇𝐎𝐎𝐋𝐒 are displayed when you meet
                        and/or exceed the minimum GPA and healthcare hours as
                        well as meet and/or exceed the average GPA and
                        healthcare hours of students accepted in the prior
                        cycle.⁣
                      </p>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn
                        @click="showRecommendedDialog = false"
                        block
                        color="red"
                        dark
                        class="elevation-0"
                        >Close</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-divider></v-divider>
                <v-row>
                  <v-col
                    v-for="school in recommendedSchools"
                    :key="school.id"
                    md="6"
                    sm="12"
                    class="pt-0"
                  >
                    <v-card avatar tile class="mx-2 mt-2 tileCard">
                      <v-list class="background pt-1 mt-0" two-line suheader>
                        <v-list-item @click="moreInfo(school.school_name)">
                          <v-list-item-avatar class>
                            <img :src="school.program_image" alt />
                          </v-list-item-avatar>

                          <v-list-item-content>
                            <v-list-item-title
                              class="blue--text text--darken-3"
                              >{{ school.school_name }}</v-list-item-title
                            >
                            <v-list-item-subtitle>{{
                              school.program_state
                            }}</v-list-item-subtitle>
                            <v-list-item-subtitle
                              class="green--text text--lighten-2"
                            >
                              <v-icon small class="mb-1" color="green lighten-2"
                                >mdi-thumb-up</v-icon
                              >
                              <span
                                v-if="
                                  parseFloat(
                                    school.gpa_overall_average_accepted_previous_year
                                  ) <= parseFloat(searchOverallGpa) &&
                                  parseFloat(
                                    school.gpa_science_average_accepted_previous_year
                                  ) <= parseFloat(searchScienceGpa) &&
                                  parseFloat(
                                    school.healthcare_experience_average_accepted_previous_year.replace(
                                      /,/g,
                                      ''
                                    )
                                  ) <= parseFloat(minimumHealthcareHours)
                                "
                                >Highly</span
                              >
                              Recommended
                            </v-list-item-subtitle>
                          </v-list-item-content>

                          <v-list-item-action>
                            <v-btn class icon rounded :ripple="false">
                              <v-icon color="grey">mdi-chevron-right</v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
              <v-card outlined class="mt-4">
                <v-toolbar flat class="pb-0">
                  <v-icon>mdi-school</v-icon>
                  <v-toolbar-title class="ml-2 pb-0">
                    {{ filteredSchools.length }}
                    <span class="ml-2">Total Matched Schools</span>
                  </v-toolbar-title>

                  <v-spacer></v-spacer>
                </v-toolbar>
                <v-divider></v-divider>
                <v-row>
                  <v-col
                    v-for="school in filteredSchools"
                    :key="school.id"
                    md="6"
                    sm="12"
                    class="pt-0"
                  >
                    <v-card avatar tile class="mx-2 mt-2 tileCard">
                      <v-list class="background pt-1 mt-0" two-line suheader>
                        <v-list-item @click="moreInfo(school.school_name)">
                          <v-list-item-avatar class>
                            <img :src="school.program_image" alt />
                          </v-list-item-avatar>

                          <v-list-item-content>
                            <v-list-item-title
                              class="blue--text text--darken-3"
                              >{{ school.school_name }}</v-list-item-title
                            >
                            <v-list-item-subtitle>{{
                              school.program_state
                            }}</v-list-item-subtitle>
                          </v-list-item-content>

                          <v-list-item-action>
                            <v-btn class icon rounded :ripple="false">
                              <v-icon color="grey">mdi-chevron-right</v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </div>

            <!-- Desktop Results -->
            <div class="criteriaContainer hidden-sm-and-down">
              <!-- Recommended Schools Card -->
              <v-card
                v-if="recommendedSchools.length !== 0"
                flat
                class="mt-2"
                outlined
              >
                <v-toolbar flat>
                  <v-icon color="green">mdi-thumb-up</v-icon>
                  <v-toolbar-title class="ml-2 green--text">
                    {{ recommendedSchools.length }}
                    <span class="ml-2">Recommended Schools</span>
                  </v-toolbar-title>

                  <v-spacer></v-spacer>

                  <v-icon @click="showRecommendedDialog = true"
                    >mdi-information</v-icon
                  >
                </v-toolbar>
                <!-- Recommended Schools Info Dialog -->
                <v-dialog
                  v-model="showRecommendedDialog"
                  scrollable
                  max-width="400"
                  style="zindex: 2000"
                  persistent
                >
                  <v-card style="borderradius: 5px">
                    <v-card-title class="title grey lighten-2"
                      >Recommended Schools</v-card-title
                    >
                    <v-card-text class="text-xs-justify mt-2">
                      𝐑𝐄𝐂𝐎𝐌𝐌𝐄𝐍𝐃𝐄𝐃 𝐒𝐂𝐇𝐎𝐎𝐋𝐒 are displayed when you meet and/or
                      exceed either the minimum GPA or the minimum healthcare
                      hours of students accepted in the prior cycle.⁣ ⁣
                      <p class="mt-2">
                        𝐇𝐈𝐆𝐇𝐋𝐘 𝐑𝐄𝐂𝐎𝐌𝐌𝐄𝐍𝐃𝐄𝐃 𝐒𝐂𝐇𝐎𝐎𝐋𝐒 are displayed when you meet
                        and/or exceed the minimum GPA and healthcare hours as
                        well as meet and/or exceed the average GPA and
                        healthcare hours of students accepted in the prior
                        cycle.⁣
                      </p>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn
                        @click="showRecommendedDialog = false"
                        block
                        color="red"
                        dark
                        class="elevation-0"
                        >Close</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-divider></v-divider>
                <v-row class="mx-1">
                  <v-col
                    class="pt-0"
                    sm="6"
                    md="6"
                    v-for="school in recommendedSchools"
                    :key="school.id"
                  >
                    <v-card class="mt-5" hover @click="moreInfo(school.school_name)">
                      <v-card-title class="d-block text-truncate">
                        <v-avatar>
                          <img :src="school.program_image" />
                        </v-avatar>
                        {{ school.school_name }}
                      </v-card-title>

                      <v-card-text class="pt-1">
                        <span
                          class="green--text text--lighten-2 font-weight-medium"
                        >
                          <v-icon class="mb-1" color="green lighten-2"
                            >mdi-thumb-up</v-icon
                          >
                          <span
                            v-if="
                              parseFloat(
                                school.gpa_overall_average_accepted_previous_year
                              ) <= parseFloat(searchOverallGpa) &&
                              parseFloat(
                                school.gpa_science_average_accepted_previous_year
                              ) <= parseFloat(searchScienceGpa) &&
                              parseFloat(
                                school.healthcare_experience_average_accepted_previous_year.replace(
                                  /,/g,
                                  ''
                                )
                              ) <= parseFloat(minimumHealthcareHours)
                            "
                            >Highly</span
                          >
                          Recommended <br />
                        </span>
                        <span class="text--primary">
                          State: <span>{{ school.program_state }}</span>
                        </span>
                        <br />
                        <span class="text--primary">
                          Accreditation Status:
                          <span
                            :class="{
                              'red--text':
                                school.accreditation_status === 'Withheld',
                              'amber--text text--darken-3':
                                school.accreditation_status === 'Probationary',
                              'blue--text text--lighten-1':
                                school.accreditation_status === 'Provisional',
                              'green--text':
                                school.accreditation_status === 'Continued',
                            }"
                            >{{ school.accreditation_status }}</span
                          >
                        </span>
                        <br />
                        <span class="text--primary">
                          <span>
                            Application Deadline:
                            <span
                              v-if="
                                school.application_deadline !== '' &&
                                school.caspa_participant
                              "
                              class="subheading mb-0"
                            >
                              {{
                                school.application_deadline
                                  | moment(" MM/DD/YYYY")
                              }}
                            </span>
                          </span>
                          <br />
                        </span>

                        <div class="stripeBox">
                          <span
                            :class="{
                              'red--stripe':
                                school.accreditation_status === 'Withheld',
                              'amber--stripe':
                                school.accreditation_status === 'Probationary',
                              'blue--stripe':
                                school.accreditation_status === 'Provisional',
                              'green--stripe':
                                school.accreditation_status === 'Continued',
                              'grey--stripe':
                                school.accreditation_status ===
                                  'Developing-Not Accredited' ||
                                school.accreditation_status === 'Pending',
                            }"
                          ></span>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
              <!-- All Matched Schools Card -->
              <v-card class="mt-4" outlined>
                <v-toolbar flat>
                  <v-icon>mdi-school</v-icon>
                  <v-toolbar-title class="ml-2">
                    {{ filteredSchools.length }}
                    <span class="ml-2">Total Matched Schools</span>
                  </v-toolbar-title>

                  <v-spacer></v-spacer>
                </v-toolbar>
                <v-divider></v-divider>
                <v-row class="mx-1">
                  <v-col
                    class="pt-0"
                    sm="6"
                    md="6"
                    v-for="school in filteredSchools"
                    :key="school.id"
                  >
                    <v-card class="mt-5" hover @click="moreInfo(school.school_name)">
                      <v-card-title class="d-block text-truncate">
                        <v-avatar>
                          <img :src="school.program_image" />
                        </v-avatar>
                        {{ school.school_name }}
                      </v-card-title>

                      <v-card-text class="pt-1">
                        <span class="text--primary">
                          State: <span>{{ school.program_state }}</span>
                        </span>
                        <br />
                        <span class="text--primary">
                          Accreditation Status:
                          <span
                            :class="{
                              'red--text':
                                school.accreditation_status === 'Withheld',
                              'amber--text text--darken-3':
                                school.accreditation_status === 'Probationary',
                              'blue--text text--lighten-1':
                                school.accreditation_status === 'Provisional',
                              'green--text':
                                school.accreditation_status === 'Continued',
                            }"
                            >{{ school.accreditation_status }}</span
                          >
                        </span>
                        <br />
                        <span class="text--primary">
                          <span>
                            Application Deadline:
                            <span
                              v-if="
                                school.application_deadline !== '' &&
                                school.caspa_participant
                              "
                              class="subheading mb-0"
                            >
                              {{
                                school.application_deadline
                                  | moment(" MM/DD/YYYY")
                              }}
                            </span>
                          </span>
                          <br />
                        </span>

                        <div class="stripeBox">
                          <span
                            :class="{
                              'red--stripe':
                                school.accreditation_status === 'Withheld',
                              'amber--stripe':
                                school.accreditation_status === 'Probationary',
                              'blue--stripe':
                                school.accreditation_status === 'Provisional',
                              'green--stripe':
                                school.accreditation_status === 'Continued',
                            }"
                          ></span>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </div>
          </v-container>
        </div>
      </v-card>

      <v-layout
        row
        align-center
        justify-center
        class="buttonFixed ml-0 pl-0 pb-8 mb-10 d-md-none"
        style="width: 100%; marginbottom: 100px; zindex: 1"
      >
        <v-btn
          v-if="showResults === false"
          color="green lighten-1 "
          class="elevation-6"
          dark
          large
          @click="showSchools"
          >View Results</v-btn
        >
        <v-btn
          v-if="showResults"
          class="px-4 elevation-6"
          color="amber darken-1"
          dark
          large
          @click="showResults = !showResults"
        >
          <v-icon small class="mr-2">mdi-filter</v-icon>Edit Filter
        </v-btn>
      </v-layout>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Vue from "vue";
import { filterZeroArrays } from "@/lib/utils";
import userMixins from "@/mixins/usersmixin";
let COURSES = [];
export default {
  mixins: [userMixins],
  data() {
    return {
      cadaverLab: null,
      faithBasedLearning: null,
      showRecommendedDialog: false,
      showPacatInfoDialog: false,
      showCasperInfoDialog: false,
      noSchoolMatch: false,
      selection: 2,
      tuitionOption: "in state",
      cycleOption: "2021cycle",
      showHighSchoolEntryInfoDialog: false,
      showFreshmenEntryInfoDialog: false,
      showRollingAdmissionsInfoDialog: false,
      showGpaInfoDialog: false,
      showDeadlineInfoDialog: false,
      showHealthcareInfoDialog: false,
      showPaShadowingInfoDialog: false,
      showGreInfoDialog: false,
      showAccreditationInfoDialog: false,
      showFilter: false,
      showResults: false,
      signupLoginDialog: false,
      activeSubscriptionDialog: false,
      menu2: false,
      menu3: false,
      includeCoursesState: "true",
      searchStatus: null,
      searchPaShadowing: this.maxPaShadowingHours,
      searchState: [],
      stateChip: true,
      searchMinGpa: null,
      searchOverallGpa: null,
      searchScienceGpa: null,
      healthcareExperience: null,
      minimumHealthcareHours: null,
      paShadowing: null,
      minimumPaShadowingHours: null,
      gre: null,
      mcatAccepted: null,
      greExempt: null,
      casperRequired: null,
      pacatRequired: null,
      preProfessionalTrack: null,
      rollingAdmissions: null,
      freshmenEntry: null,
      highSchoolEntry: null,
      onlineProgram: null,
      internationalStudents: null,
      militaryOnly: null,
      highSchoolEntry: null,
      partTimeOption: null,
      onCampusHousing: null,
      application_deadline: null,
      application_classStartMonth: null,
      tuition: null,
      accreditationStatus: null,
      date: null,
      courses: null,
      selectedCategory: [],
      status: [
        "Continued",
        "Provisional",
        "Probationary",
        "Administrative Probation",
        "Developing-Not Accredited",
      ],
      states: [
        "Alabama",
        "Alaska",
        "Arizona",
        "Arkansas",
        "California",
        "Colorado",
        "Connecticut",
        "Delaware",
        "District of Columbia",
        "Florida",
        "Georgia",
        "Hawaii",
        "Idaho",
        "Illinois",
        "Indiana",
        "Iowa",
        "Kansas",
        "Kentucky",
        "Louisiana",
        "Maine",
        "Maryland",
        "Massachusetts",
        "Michigan",
        "Minnesota",
        "Mississippi",
        "Missouri",
        "Montana",
        "Nebraska",
        "Nevada",
        "New Hampshire",
        "New Jersey",
        "New Mexico",
        "New York",
        "North Carolina",
        "North Dakota",
        "Ohio",
        "Oklahoma",
        "Oregon",
        "Pennsylvania",
        "Puerto Rico",
        "Rhode Island",
        "South Carolina",
        "South Dakota",
        "Tennessee",
        "Texas",
        "Utah",
        "Vermont",
        "Virginia",
        "Washington",
        "West Virginia",
        "Wisconsin",
        "Wyoming",
      ],
      incExcCourse: [
        {
          title: "macro 1",
          courses: [
            "macro 1 / micro 1",
            "macro 1 / micro 2",
            "macro 1 / micro 3",
          ],
        },
        {
          title: "macro 2",
          courses: [
            "macro 2 / micro 1",
            "macro 2 / micro 2",
            "macro 2 / micro 3",
          ],
        },
        {
          title: "macro 3",
          courses: [
            "macro 3 / micro 1",
            "macro 3 / micro 2",
            "macro 3 / micro 3",
          ],
        },
      ],
    };
  },
  methods: {
    async fetchCourses() {
      const snap = await this.$firebase.database().ref("courses").once("value");
      if (!snap.exists()) return null;
      Vue.set(this, "courses", snap.val());
      COURSES = snap.val();
    },
    back() {
      this.$router.go("-1");
    },
    moreInfo(id) {
      console.log(id)
      this.$router.push("/paschool/" + id.split(' ').join('-'));
    },
    showSchools() {
      if (this.filteredSchools.length === 0 || !this.checkIfFilterWasUsed) {
        return (this.noSchoolMatch = true);
      }

      if (!this.checkUserLoggedIn) {
        this.signupLoginDialog = true;
      }
      if (!this.checkUserIsSubscribed) {
        this.activeSubscriptionDialog = true;
      } else {
        this.showResults = true;
        window.scrollTo(0, 0);
      }
    },
    removeState(state) {
      const index = this.searchState.indexOf(state);
      this.searchState.forEach((value) => {
        if (value === state) {
          this.searchState.splice(index, 1);
        }
      });
    },
    removeOverallGpa() {
      this.searchOverallGpa = "";
    },
    removeScienceGpa() {
      this.searchScienceGpa = "";
    },
    removeGpaNotRequired() {
      this.searchMinGpa = "";
    },
    removeHealthcareHours() {
      this.minimumHealthcareHours = "";
    },
    removeHealthcareHoursNotRequired() {
      this.healthcareExperience = "";
    },
    removePaShadowingHours() {
      this.minimumPaShadowingHours = "";
    },
    removePaShadowingHoursNotRequired() {
      this.paShadowing = "";
    },
    removeGreNotRequired() {
      this.gre = "";
    },
    removeGreRequired() {
      this.gre = "";
    },
    removeMcatAccepted() {
      this.mcatAccepted = "";
    },
    removeGreExemptRequired() {
      this.greExempt = "";
    },
    removeHighSchoolEntry() {
      this.highSchoolEntry = "";
    },
    removepreProfessionalTrack() {
      this.preProfessionalTrack = "";
    },
    removepreRollingAdmissions() {
      this.rollingAdmissions = "";
    },
    removeOnlineProgram() {
      this.onlineProgram = "";
    },
    removeInternationalStudents() {
      this.internationalStudents = "";
    },
    removePartTimeOption() {
      this.partTimeOption = "";
    },
    removeOnCampusHousing() {
      this.onCampusHousing = "";
    },
    removeTuition() {
      this.tuition = "";
    },
    removeMilitaryOnly() {
      this.militaryOnly = "";
    },
  },
  computed: {
    computedDateFormattedMomentjs() {
      return this.application_deadline
        ? moment(this.application_deadline).format("MMM/YY")
        : "";
    },
    schools() {
      return this.$store.getters.loadedSchools;
    },

    user() {
      return this.$store.getters.user;
    },
    verifiedSchools() {
      return this.schools.filter((school) => {
        if (school.verified === true) {
          return school;
        } else {
          return false;
        }
      });
    },
    checkIfFilterWasUsed() {
      if (
        this.selectedCategory.length ||
        this.searchState.length !== 0 ||
        this.searchMinGpa !== null ||
        (this.searchOverallGpa !== null && this.searchOverallGpa !== "") ||
        (this.searchScienceGpa !== null && this.searchScienceGpa !== "") ||
        this.healthcareExperience !== null ||
        (this.minimumHealthcareHours !== null &&
          this.minimumHealthcareHours !== "") ||
        this.paShadowing !== null ||
        (this.minimumPaShadowingHours !== null &&
          this.minimumPaShadowingHours !== "") ||
        this.gre !== null ||
        this.mcatAccepted !== null ||
        this.greExempt !== null ||
        this.preProfessionalTrack !== null ||
        this.rollingAdmissions !== null ||
        this.freshmenEntry !== null ||
        this.highSchoolEntry !== null ||
        this.militaryOnly !== null ||
        this.onlineProgram !== null ||
        this.internationalStudents !== null ||
        this.partTimeOption !== null ||
        this.onCampusHousing !== null ||
        this.application_deadline !== null ||
        this.application_classStartMonth !== null ||
        this.tuition !== null ||
        (this.accreditationStatus !== null &&
          this.accreditationStatus !== undefined) ||
        this.date !== null ||
        this.casperRequired !== null ||
        this.pacatRequired !== null ||
        this.cadaverLab !== null ||
        this.faithBasedLearning !== null
      ) {
        return true;
      } else {
        return false;
      }
    },
    courseCategories() {
      if (!this.courses) return [];
      const reducedCourses = this.verifiedSchools.reduce((courses, school) => {
        school.required_courses.forEach((course) => {
          if (this.courses[course.id]) {
            const matchingCource = this.courses[course.id];
            if (!courses[matchingCource.course_subject_category]) {
              courses[matchingCource.course_subject_category] = {
                title: matchingCource.course_subject_category,
                courses: [],
              };
            }

            if (
              courses[matchingCource.course_subject_category].courses.indexOf(
                matchingCource.course_name
              ) == -1
            ) {
              courses[matchingCource.course_subject_category].courses.push(
                matchingCource.course_name
              );
            }
          }
        });
        return courses;
      }, {});
      return Object.values(reducedCourses);
    },
    filteredSchools() {
      return (
        this.verifiedSchools
          .filter((school) => {
            if (this.searchState.length !== 0) {
              return this.searchState.find((state) => {
                return (
                  school.program_state.replace(/[, ]+/g, "").toLowerCase() ===
                  state.replace(/\s/g, "").toLowerCase()
                );
              });
            } else {
              return true;
            }
          })
          .filter((school) => {
            if (this.militaryOnly === "true") {
              return school.school_name === "Interservice";
            } else return true;
          })

          .filter((school) => {
            if (this.paShadowing === "not required") {
              return (
                school.pa_shadowing_required === false &&
                school.pa_shadowing_recommended === false
              );
            }
            // PA Shadowing Recommended
            if (this.paShadowing === "recommended") {
              return (
                school.pa_shadowing_recommended === true &&
                school.pa_shadowing_required === false
              );
            }
            // PA Shadowing Required
            if (this.paShadowing === "required") {
              return (
                school.pa_shadowing_required === true &&
                school.pa_shadowing_recommended === false
              );
            } else {
              return true;
            }
          })
          // Search Minimum User PA Shadowing Hours
          .filter((school) => {
            if (
              this.minimumPaShadowingHours !== "" &&
              this.minimumPaShadowingHours !== null &&
              this.paShadowing !== "not required"
            ) {
              return (
                parseInt(school.pa_shadowing_minimum_hours) <=
                  parseInt(this.minimumPaShadowingHours) ||
                school.pa_shadowing_recommended === true
              );
            } else {
              return true;
            }
          })
          .filter((school) => {
            if (this.casperRequired === "true") {
              return school.casper_accepted === true;
            }
            if (this.casperRequired === "false") {
              return school.casper_accepted === false;
            } else {
              return true;
            }
          })
          .filter((school) => {
            if (this.pacatRequired === "true") {
              return school.pacat_required === true;
            }
            if (this.pacatRequired === "false") {
              return (
                school.pacat_required === false ||
                school.pacat_required === undefined
              );
            } else {
              return true;
            }
          })
          .filter((school) => {
            if (this.gre === "required") {
              return school.gre_required === true;
            }
            if (this.gre === "not required") {
              return school.gre_required === false;
            }
            if (this.greExempt === "true" && this.gre !== "not required") {
              return school.gre_exempt_masters_doctoral_degrees === true;
            } else {
              return true;
            }
          })
          .filter((school) => {
            if (this.mcatAccepted === "true" && this.gre !== "not required") {
              return school.mcat_accepted_instead_gre === true;
            } else {
              return true;
            }
          })
          .filter((school) => {
            if (this.searchMinGpa === "not required") {
              return school.gpa_minimum_required === false;
            } else {
              return true;
            }
          })
          .filter((school) => {
            if (
              this.searchMinGpa !== "not required" &&
              school.gpa_overall_minimum !== "" &&
              this.searchOverallGpa !== "" &&
              this.searchOverallGpa !== null
            ) {
              return (
                parseFloat(school.gpa_overall_minimum) <=
                parseFloat(this.searchOverallGpa)
              );
            } else {
              return true;
            }
          })
          .filter((school) => {
            if (
              this.searchMinGpa !== "not required" &&
              school.gpa_science_minimum !== "" &&
              this.searchScienceGpa !== "" &&
              this.searchScienceGpa !== null
            ) {
              return (
                parseFloat(school.gpa_science_minimum) <=
                parseFloat(this.searchScienceGpa)
              );
            } else {
              return true;
            }
          })
          .filter((school) => {
            if (this.healthcareExperience === "not required") {
              return (
                school.healthcare_experience_required === false &&
                school.healthcare_experience_recommended === false
              );
            }

            if (this.healthcareExperience === "recommended") {
              return (
                school.healthcare_experience_recommended === true &&
                school.healthcare_experience_required === false
              );
            } else {
              return true;
            }
          })
          // Filter Minimum Healthcare Hours
          .filter((school) => {
            if (
              this.minimumHealthcareHours !== "" &&
              this.healthcareExperience !== "not required" &&
              this.minimumHealthcareHours !== null
            ) {
              return (
                parseInt(
                  school.healthcare_experience_minimum_hours.replace(
                    /[, ]+/g,
                    ""
                  )
                ) <= parseInt(this.minimumHealthcareHours.replace(/,/g, "")) ||
                school.healthcare_experience_required === false
              );
            } else {
              return true;
            }
          })

          .filter((school) => {
            if (this.rollingAdmissions === "true") {
              return school.rolling_admissions === true;
            } else {
              return true;
            }
          })
          .filter((school) => {
            if (this.rollingAdmissions === "false") {
              return school.rolling_admissions === false;
            } else {
              return true;
            }
          })
          .filter((school) => {
            if (this.onlineProgram === "true") {
              return school.distance_online_learning === true;
            } else {
              return true;
            }
          })
          .filter((school) => {
            if (this.highSchoolEntry === "true") {
              return school.high_school_entry === true;
            } else {
              return true;
            }
          })
          .filter((school) => {
            if (this.internationalStudents === "true") {
              return school.accepts_international_students === true;
            } else {
              return true;
            }
          })
          .filter((school) => {
            if (this.partTimeOption === "true") {
              return school.part_time_option === true;
            } else {
              return true;
            }
          })
          .filter((school) => {
            if (this.cadaverLab === "true") {
              return school.cadaver_lab === true;
            } else {
              return true;
            }
          })
          .filter((school) => {
            if (this.faithBasedLearning === "true") {
              return school.faith_based === true;
            } else {
              return true;
            }
          })

          .filter((school) => {
            if (this.onCampusHousing === "true") {
              return school.on_campus_housing === true;
            } else {
              return true;
            }
          })

          .filter((school) => {
            if (this.preProfessionalTrack === "true") {
              return school.preprofessional_degree_required === true;
            } else {
              return true;
            }
          })

          .filter((school) => {
            if (
              this.application_deadline !== "" &&
              this.application_deadline !== null &&
              this.application_deadline !== undefined
            ) {
              if (this.cycleOption === "2024cycle") {
                return moment(moment(school.application_deadline)).isBetween(
                  moment(this.application_deadline),
                  moment("2025-04-01")
                );
                // && moment(school.application_deadline).format('MMMM YYYY') <= moment('2020-04-15').format('MMMM YYYY')
              }
           
              if (this.cycleOption === "2025cycle") {
                return moment(moment(school.application_deadline)).isBetween(
                  moment(this.application_deadline),
                  moment("2026-04-01")
                );
                // && moment(school.application_deadline) <= moment('2020-04-15')
              }
            } else {
              return true;
            }
          })
          // Class Start Month
          .filter((school) => {
            if ( this.application_classStartMonth !== "" && 
                  this.application_classStartMonth !== null && 
                  this.application_classStartMonth !== undefined
              ) { 
                const checkMonth = Number(this.application_classStartMonth.split('-')[1]) - 1
                const schoolMonth = new Date(school.program_start_date).getMonth()
                return checkMonth === schoolMonth //? true : false
            } else {
              return true;
            }
          })
          // Test Tuition Filters
          .filter((school) => {
            if (this.tuitionOption === "in state") {
              if (this.tuition === "lessThan50") {
                return (
                  parseInt(
                    school.tuition_in_state_resident.replace(/[, ]+/g, "")
                  ) < 50000
                );
              }

              if (this.tuition === "50to100") {
                return (
                  parseInt(
                    school.tuition_in_state_resident.replace(/[, ]+/g, "")
                  ) >= 50000 &&
                  parseInt(
                    school.tuition_in_state_resident.replace(/[, ]+/g, "")
                  ) <= 100000
                );
              }
              if (this.tuition === "100to150") {
                return (
                  parseInt(
                    school.tuition_in_state_resident.replace(/[, ]+/g, "")
                  ) >= 100000 &&
                  parseInt(
                    school.tuition_in_state_resident.replace(/[, ]+/g, "")
                  ) <= 150000
                );
              }
              if (this.tuition === "greaterThan150") {
                return (
                  parseInt(
                    school.tuition_in_state_resident.replace(/[, ]+/g, "")
                  ) > 150000
                );
              } else {
                return true;
              }
            }
            if (this.tuitionOption === "out of state") {
              if (this.tuition === "lessThan50") {
                return (
                  parseInt(
                    school.tuition_out_of_state_nonresident.replace(
                      /[, ]+/g,
                      ""
                    )
                  ) < 50000
                );
              }

              if (this.tuition === "50to100") {
                return (
                  parseInt(
                    school.tuition_out_of_state_nonresident.replace(
                      /[, ]+/g,
                      ""
                    )
                  ) >= 50000 &&
                  parseInt(
                    school.tuition_out_of_state_nonresident.replace(
                      /[, ]+/g,
                      ""
                    )
                  ) <= 100000
                );
              }
              if (this.tuition === "100to150") {
                return (
                  parseInt(
                    school.tuition_out_of_state_nonresident.replace(
                      /[, ]+/g,
                      ""
                    )
                  ) >= 100000 &&
                  parseInt(
                    school.tuition_out_of_state_nonresident.replace(
                      /[, ]+/g,
                      ""
                    )
                  ) <= 150000
                );
              }
              if (this.tuition === "greaterThan150") {
                return (
                  parseInt(
                    school.tuition_out_of_state_nonresident.replace(
                      /[, ]+/g,
                      ""
                    )
                  ) > 150000
                );
              } else {
                return true;
              }
            }
          })
          // Accredidation Status
          .filter((school) => {
            if (this.accreditationStatus === "Continued") {
              return school.accreditation_status === "Continued";
            }
            if (this.accreditationStatus === "Provisional") {
              return school.accreditation_status === "Provisional";
            }
            if (this.accreditationStatus === "Probationary") {
              return school.accreditation_status === "Probationary";
            }
            if (this.accreditationStatus === "Administrative Probation") {
              return school.accreditation_status === "Administrative Probation";
            }
            if (this.accreditationStatus === "Developing-Not Accredited") {
              return (
                school.accreditation_status === "Developing-Not Accredited"
              );
            } else {
              return true;
            }
          })
          // Prerequisites
          .filter((school) => {
            if (!this.selectedCategory.length) return true;
            const requiredCourses = filterZeroArrays(school.required_courses);
            const courseGorupings = filterZeroArrays(
              school.optional_courses_group
            );
            const recommendedCourses = filterZeroArrays(school.recommended_courses)
            if (courseGorupings.length) {
              const hasAllOptional = courseGorupings.some(
                ({ options = [] }) => {
                  const optionalCourses = filterZeroArrays(options);
                  return options.every(({ course_name }) =>
                    this.selectedCategory.includes(course_name)
                  );
                }
              );
              if (hasAllOptional) {
                return this.shouldIncludeSchoolsFilter ? true : false;
              }
            }

            if (recommendedCourses.length && !this.shouldIncludeSchoolsFilter) {
              const hasAllOptional = recommendedCourses.some(
                ({ options = [] }) => {
                  const optionalCourses = filterZeroArrays(options);
                  return options.every(({ course_name }) =>
                    this.selectedCategory.includes(course_name)
                  );
                }
              );
              if (hasAllOptional) {
                return this.shouldIncludeSchoolsFilter ? true : false;
              }
            }

            return this.selectedCategory.every((cname) => {
              const exists = requiredCourses.find(
                ({ course_name }) => cname == course_name
              );
              return this.shouldIncludeSchoolsFilter ? exists : !exists;
            });
          })
      );
    },
    shouldIncludeSchoolsFilter() {
      return this.includeCoursesState === "true";
    },
    recommendedSchools() {
      return this.filteredSchools.filter((school) => {
        if (
          (parseFloat(school.gpa_overall_average_accepted_previous_year) <=
            parseFloat(this.searchOverallGpa) &&
            parseFloat(school.gpa_science_average_accepted_previous_year) <=
              parseFloat(this.searchScienceGpa)) ||
          parseFloat(
            school.healthcare_experience_average_accepted_previous_year.replace(
              /,/g,
              ""
            )
          ) <= parseFloat(this.minimumHealthcareHours)
        ) {
          return school;
        }
      });
    },
  },

  filters: {
    capitalizeString(string) {
      if (moment(string).format("MMMM") === "January") {
        return "January";
      }
    },
  },

  created() {
    if (COURSES.length === 0) {
      this.fetchCourses();
    }
  },
};
</script>

<style scoped>
.v-expansion-panel-header {
  border: none !important;
}
.v-expansion-panel::before {
  box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.19) !important;
}
.background {
  background-color: rgb(255, 255, 255);
}
.deskTopHeader {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  background-color: yellow;
  padding: 50px;
  font-size: 20px;
}
.maxContainer {
  max-width: 1280px;
  margin: 0 auto;
}
.destopAligner {
  text-align: center;
  margin-left: 300px;
}

@media (min-width: 960px) {
  .headerFake__back {
    display: block;
  }
  .fixed {
    display: none;
  }
  .container {
    max-width: 80%;
  }
  .criteriaContainer {
    max-width: 60%;
    margin-left: 40%;
    z-index: 2;
    position: relative;
  }

  .filterBarContainer {
    position: fixed;
    z-index: 1;
    top: 100px;
    left: 0;
    width: 100%;
    height: calc(100% - 200px);
    overflow-y: auto;
  }

  .filterBarContainer__wrapper {
    width: 35%;
    text-align: left;
  }

  .destopAligner {
    text-align: right;
    margin-left: 40%;
  }

  .chipContainer {
    margin: 0 -8px;
  }
}

@media (max-width: 900px) {
  .containerCard {
    margin-top: 40px;
  }
  #filter {
    margin-bottom: 80px;
  }
}

/* #filter {
  margin-top: 70px;
} */

.fixed {
  position: fixed;
}

.fixedHeader {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
}

#buttonShadow {
  box-shadow: 0 10px 20px -5px rgba(0, 0, 0, 0.19);
}
.buttonShadow {
  box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.19);
  border-radius: 1px solid grey;
}

.buttonFixed {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1000 !important;
}

.tileCard {
  border-radius: 10px;
  box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.19);
}

.scrolling-wrapper {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  padding-bottom: 15px;

  padding-right: 10px;
}

.scrolling-wrapper {
  -webkit-overflow-scrolling: touch;
}

.chip {
  flex: 0 0 auto;
}
.maxContainer {
  max-width: 1280px;
  margin: 0 auto;
}

.fullWidth {
  width: 100%;
}

.stripeBox {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 8px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  overflow: hidden;
}

.red--stripe,
.amber--stripe,
.blue--stripe,
.green--stripe,
.grey--stripe {
  border-top: 10px solid transparent;
  display: block;
}
.red--stripe {
  border-color: #f44336;
}
.amber--stripe {
  border-color: #ff8f00;
}
.blue--stripe {
  border-color: #42a5f5;
}
.green--stripe {
  border-color: #4caf50;
}
.grey--stripe {
  border-color: #777777;
}

.titleAlign {
  text-align: center;
  width: 100%;
  padding-bottom: 12px;
}

.v-application .title.incExcTitle {
  font-size: 16px !important;
}

.makeItDouble {
  width: 100%;
}

.makeItDouble__cont {
  padding: 0 12px;
}

@media (min-width: 900px) {
  .makeItDouble {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }
  .makeItDouble > div {
    max-width: 50%;
  }

  .makeItDouble > div.v-expansion-panel--active + .v-expansion-panel,
  .makeItDouble > div.v-expansion-panel--active:not(:first-child) {
    margin-top: 0;
    border-top: 1px solid #d8d8d8;
  }

  .makeItDouble > div:first-child,
  .makeItDouble > div.v-expansion-panel--active + .v-expansion-panel {
    border-top: 1px solid #d8d8d8;
  }
}

.v-application--is-ltr
  .v-tabs-bar.v-tabs-bar--is-mobile:not(.v-tabs-bar--show-arrows)
  > .v-slide-group__wrapper
  > .v-tabs-bar__content
  > .v-tab:first-child,
.v-application--is-ltr
  .v-tabs-bar.v-tabs-bar--is-mobile:not(.v-tabs-bar--show-arrows)
  > .v-slide-group__wrapper
  > .v-tabs-bar__content
  > .v-tabs-slider-wrapper
  + .v-tab {
  margin-left: 0;
}

.IncExcCourseTab .v-tab {
  text-transform: inherit;
}

@media (max-width: 768px) {
  .showOnlyTabletUp {
    display: none;
  }
}
@media (min-width: 768px) {
  .showOnlyMobile {
    display: none;
  }
}

.fixScrollBar.v-sheet > :first-child:not(.v-btn):not(.v-chip) {
  z-index: 100;
}

.wrap {
   padding-top:7vh;
}

.yellow__text {
  color: #005880;
}

.boldText {
    color: #005880;
}
</style>



// WEBPACK FOOTER //
// src/components/PaSchoolFinder/PaSchoolFinder.vue